import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { QuotaLackTO } from "../../../../../../../shared/cw-backend/models/attendance/QuotaLack";
// default
import { Location } from "@angular/common";
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Inject,
    OnDestroy,
    OnInit,
    Renderer2,
    TemplateRef,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { MatTabGroup } from "@angular/material/tabs";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
// fuse
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { AttendanceMaterialComponent } from "app/layout/components/attendance-material/attendance-material.component";
// backend
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import { MatChipInputEvent } from "@angular/material/chips";
import { AlertModalComponent } from "app/layout/components/alert-modal/alert-modal.component";
import { DialogDbProcedureComponent } from "app/layout/components/db-diagnostic/dialog-db-procedure/dialog-db-procedure.component";
import { ModalDefaultersComponent } from "app/main/modals/modal-defaulters/modal-defaulters.component";
import { ExclusionMotiveComponent } from "app/main/modules/operational/reception/os/components/exclusion-motive/exclusion-motive.component";
import { ThirdpartyOrderItemEditComponent } from "app/main/modules/register/organizational/thirdparty/thirdparty-order-item-edit/thirdparty-order-item-edit.component";
import { RequireMatch } from "app/validators/requireMatch";
import {
    Alert,
    AlertListProvider,
    AlertSearch,
    ApiGateway,
    Company,
    CompanyCostCenter,
    CompanyListProvider,
    CostCenter,
    FirmListProvider,
    Insurance,
    InsuranceListProvider,
    Kit,
    Order,
    OrderPayEditProvider,
    OrderPayListProvider,
    OrderPayMin,
    PageOptions,
    ParameterProvider,
    Patient,
    PatientListProvider,
    PayTypeListProvider,
    Person,
    PlanListProvider,
    QuotaLackControlEditProvider,
    Schedule,
    User,
    UserListProvider,
} from "cw-backend";
import { RolePermissionService } from "cw-services";
import * as $ from "jquery";
import * as moment from "moment";
import { BehaviorSubject, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import {
    Parameter,
    ParameterTO,
} from "../../../../../../../shared/cw-backend/models/application/parameter/parameter";
import { ParameterNameEnum } from "../../../../../../../shared/cw-backend/models/application/parameter/parameter-name-enum.enum";
import { OrderDiagnosis } from "../../../../../../../shared/cw-backend/models/attendance/order-diagnosis";
import { OrderPatientDetail } from "../../../../../../../shared/cw-backend/models/attendance/order-patient-detail";
import { OrderPayer } from "../../../../../../../shared/cw-backend/models/attendance/order-payer";
import { Session } from "../../../../../../../shared/cw-backend/models/attendance/session";
import { ReportProvider } from "../../../../../../../shared/cw-backend/providers/application/report/report.provider";
import { AttendanceEditProvider } from "../../../../../../../shared/cw-backend/providers/attendance/attendance/attendance-edit.provider";
import { AttendanceListProvider } from "../../../../../../../shared/cw-backend/providers/attendance/attendance/attendance-list.provider";
import {
    CwUtils,
    SnackBarService,
} from "../../../../../../../shared/cw-utils/cw-utils.module";
import { RefreshService } from "../../../../../../../shared/cw-utils/refresh-service";
import { ScheduleDialogOsProcedureComponent } from "../../scheduling/components/schedule-dialog-os-procedure/schedule-dialog-os-procedure.component";
import { AttestAttendanceComponent } from "./components/attest-attendance/attest-attendance.component";
import { DialogChangeInsurance } from "./components/dialog-change-insurance/dialog-change-insurance.component";
import { DialogCopyOsComponent } from "./components/dialog-copy-os/dialog-copy-os.component";
import { DialogMemoryCalcComponent } from "./components/dialog-memory-calc/dialog-memory-calc.component";
import {
    OrderItem,
    OsItemsComponent,
} from "./components/os-items/os-items.component";
import { QuickRegistrationFirmComponent } from "./components/quick-registration-firm/quick-registration-firm.component";
import { QuickRegistrationSolicComponent } from "./components/quick-registration-solic/quick-registration-solic.component";
import { TypeReceiptComponent } from "./components/type-receipt/type-receipt.component";
import { IntegrationServiceService } from "../../../../../../../shared/cw-backend/providers/attendance/integration/IntegrationService.service";

@Component({
    selector: "os",
    templateUrl: "./os.component.html",
    styleUrls: ["./os.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
    animations: [
        fuseAnimations,
        trigger("detailExpand", [
            state("collapsed", style({ height: "0px", minHeight: "0" })),
            state("expanded", style({ height: "*" })),
            transition(
                "expanded <=> collapsed",
                animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)"),
            ),
        ]),
    ],
})
export class OSComponent implements OnInit, OnDestroy {
    os = {
        number: 0,
        companyCostCenter: {
            id: 0,
        },
        patient: {
            id: 0,
        },
        insurance: {
            id: 0,
        },
        plan: {
            id: 0,
        },
        agreement: {
            id: 0,
        },
        exameType: {
            id: 0,
        },
        procedure: {
            id: 0,
        },
        date: 0,
        hour: "10:10",
        status: "",
        state: "",
        enrollment: "",
        value: 0,
        discount: 0,
    };

    @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
    @ViewChild("attendanceMaterial")
    attendanceMaterial: AttendanceMaterialComponent;
    @ViewChild("auditView") auditView: ElementRef;
    @ViewChild("dialogContent")
    dialogContent: TemplateRef<any>;
    dialogRef: any;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    exclusionDialogRef: MatDialogRef<ExclusionMotiveComponent>;
    solicRegistrationDialogRef: MatDialogRef<QuickRegistrationSolicComponent>;
    pageType: string;
    dataSource = new MatTableDataSource<any>();
    searchType = new BehaviorSubject("I");
    pageOptions: PageOptions;

    order: Order = new Order();
    orderPatientDetails: OrderPatientDetail = new OrderPatientDetail();

    //mascara
    maskRegistration: string;
    maskEnrollment: string;

    //controle de aviso
    alertList: Alert[];
    alertCountindex: number = null;

    //session
    session: Session;
    ControlSessionByParameterSystem: boolean = false;
    ControlSessionByParameterProcedure: boolean = false;
    serviceFrequencyPerWeek: String = "0";
    usageToken: String = "0";
    //image
    imageBase64: string;
    imagePath: any;

    hoverCostCenterId: any;
    osForm: FormGroup;
    osHeaderForm: FormGroup;
    itemOsForm: FormGroup;
    orderPayForm: FormGroup;
    tableName: String;
    discountControl = new FormControl(0);
    discountLoading: boolean = false;
    typeDiscount: string = "1";

    retrictionsFormFields: any;

    //Controle especialidade do profissional executante
    specialityControl = new FormControl(null, [
        Validators.required,
        RequireMatch.bind(this),
    ]);
    specialityList = new Array<any>();
    specialityPageOptions: PageOptions;
    //controle do prfessional solicitante
    professionalSolicControl = new FormControl();
    typeProfessionalSolicControl = new FormControl();
    firmSolicControl = new FormControl();

    patterQuatityParcel: string;

    //Campos para kit 2.0
    accreditationProcedureKit = new Array<Kit>();

    @ViewChild("cidInput") cidInput: ElementRef<HTMLInputElement>;
    @ViewChild("filter", { static: true })
    filter: ElementRef;
    @ViewChild("osItems", { static: true })
    osItems: OsItemsComponent;

    private _unsubscribeAll: Subject<any>;
    public argument: string;
    loading: boolean = true;
    loadingOs: boolean = false;
    loadingGenerateNumber: boolean = false;
    numberByInsurance: boolean = false;
    blockReceipt: boolean = false;
    blockGuide: boolean = false;

    useAccreditationValue = true;
    requesterRequired = false;
    requesterFirmRequired = false;
    useWebserviceDB = false;
    useWebserviceLabchekap = false;
    useWebserviceLabAlvaro = false;
    userWebserviceSulAmerica = false;
    loadingverifyEligibility: boolean = false;

    procedureRequiredProfessionalRequester = false;

    userList: User[];
    viewRegister: boolean = false;

    disabledSaveAttendance: boolean = false;

    patientList: Patient[];
    insuranceList: Insurance[] = [];
    performerList: any[] = [];
    profissionalList: any[];
    procedureList: any[] = [];
    orderList: any[] = [];
    osItensList: any[] = [];
    osPayList: any[] = [];
    patientPlanList: any[] = [];
    payTypeList: any[] = [];
    planList: any[];
    firmList: any[];
    speciality: any;
    person: Person;
    patient: Patient;
    insurance: Insurance;
    professional: any;
    mainProfissional: any;
    procedure: any;
    exameType: any = "";
    osDate: any = "";
    accreditationKitList = new Array();
    companyList = new Array<Company>();
    companySelectd = new Company();

    orderItem: OrderItem;
    kitList = new Array();

    //controle schedule atendimento
    scheduleWhithChilden = new Array<any>();
    scheduleId: number;

    //Cid
    cidListSelected = new Array();
    CIDList: any[] = [];
    cidFormControl = new FormControl(null, [Validators.required, RequireMatch.bind(this)]);

    orderInsurance: any;
    disabledTabOrder: boolean = false;

    // PageOptions
    patientPageOptions: PageOptions;
    performerPageOptions: PageOptions;
    procedurePageOptions: PageOptions;
    insurancePgaeOptions: PageOptions;
    professionalPageOptions: PageOptions;
    firmPageOptions: PageOptions;
    cidPageOptions: PageOptions;
    orderPayPageOptions: PageOptions;
    companyPgaeOptions: PageOptions;
    planPageOptions: PageOptions;
    //visibilidade dos Campos
    isRegister: boolean = false;

    //constCenter
    companyCostCenterList: CostCenter[] = [];
    mainCostCenter: CostCenter = new CostCenter();

    //tipo de Atendimento
    typeSurveyList: any[];

    // check BLOQUEIO
    lockCheck = new FormControl(false);

    // informações da OS;
    dateBillingControl = new FormControl("");
    coverBillingControl = new FormControl("");
    datePayControl = new FormControl("");
    repasseControl = new FormControl("");
    userCreatedControl = new FormControl("");
    userUpdatedControl = new FormControl("");
    //Company
    companyControl = new FormControl("");

    //Parameters
    parameterList = new Array<any>();
    parameterQuestionOnLanck: any;

    displayedColumnsItensOs = [
        //"orderItem.type",
        "gloss",
        "orderItem_code",
        "orderItem_name",
        "orderItem_performer_professional_person_name",
        //"professional_person_name",
        //"speciality_name",
        "orderItem_date",
        "orderItem_total",
        "order_item_percent",
        "orderItem_orderItemTiss_status",
        "button",
    ];
    displayedColumnsDadosPagtos = [
        "orderPay.payType.name",
        "orderPay.brand.name",
        "orderPay.date",
        "orderPay.value",
        "orderPay.receptDate",
        "button",
    ];

    //display form patient
    hideFormPatient: boolean = false;

    //display tab os
    isNewOs: boolean = false;

    //display view nem item os
    isNewItemOs: boolean = false;
    isDetailsPayment: boolean = false;
    saveItem = false;

    //tipo de lançamento
    isProcedure: boolean = true;

    //tab index
    selectedTabIndex: number = 0;
    selectedOrderItemIndex: number = 0;

    exameTypeSelected: any;

    orderPayId: number;
    orderPayMissing: string = "0";
    private readonly openPaymentPendingMessage =
        "Há pagamento em aberto nesta OS. Deseja realmente sair da tela?";
    valueAfterDiscount: number | null = null;
    discountOS: number | null = null;

    //boolean que verifica se a order tem autorização cadastrada para permitir fechar a mesma, ou alertar na edição
    isNoAuth: boolean = false;
    pdfSrc = null;
    viewPdf: boolean = false;

    //tabs vallue
    TAB_HISTORICO = 0;
    TAB_OS = 1;
    TAB_INFO_ORDER_PAYMENT = 4;
    selectedTabInfoOrderIndex = 0;
    auxiliaryList: any;
    materialKitList: any;
    drugKitList: any;
    opmeKitList: any;
    feeAccreditationList: any;
    orderItemFeeList = new Array();
    orderItemProductList = new Array();
    orderItemAuxiliaryList = new Array();
    togglePayType: boolean = false;

    //exibir campo session
    sessionView: boolean = false;
    quatitySessionCurrent: number = 0;

    //tratativa de status
    stateColor: any;
    orderStatus: any;
    orderState: any;

    //pagamento
    payTypeSubscription: any;

    //dmed
    isOrderPayer: boolean = false;
    isOrderPayerList: boolean = true;
    orderPayerDetail = new OrderPayer();
    isAdvancePaymentOrder: boolean = false;
    advancePaymentBudgetId: number = null;

    //loading
    progress: boolean = false;
    disableDeleteOrderPay: boolean = false;
    disableDeleteOrderItem: boolean = false;
    loadingAction = false;
    private updatingMainTab = false;

    constructor(
        private insuranceListProvider: InsuranceListProvider,
        private attendanceEditProvider: AttendanceEditProvider,
        private AttendanceListProvider: AttendanceListProvider,
        private orderPayListProvider: OrderPayListProvider,
        private orderPayEditProvider: OrderPayEditProvider,
        private quotaLackControlEditProvider: QuotaLackControlEditProvider,
        private payTypeListProvider: PayTypeListProvider,
        private alertListProvider: AlertListProvider,
        private planListProvider: PlanListProvider,
        private progressBar: FuseProgressBarService,
        private firmListProvider: FirmListProvider,
        public gw: ApiGateway,
        private userListProvider: UserListProvider,
        private rolePermissionService: RolePermissionService,
        private snackBar: SnackBarService,
        private _router: Router,
        private _formBuilder: FormBuilder,
        private _matDialog: MatDialog,
        private patientListProvider: PatientListProvider,
        private _sanitizer: DomSanitizer,
        private location: Location,
        private attendanceListProvider: AttendanceListProvider,
        private reportprovider: ReportProvider,
        private route: ActivatedRoute,
        private companyListProvider: CompanyListProvider,
        private parameterProvider: ParameterProvider,
        private fuseProgessBar: FuseProgressBarService,
        private cdr: ChangeDetectorRef,
        private renderer: Renderer2,
        private el: ElementRef,
        private refreshService: RefreshService,
        private integrationService: IntegrationServiceService
    ) {
        this._unsubscribeAll = new Subject();
        this.pageOptions = new PageOptions();
        this.insurancePgaeOptions = new PageOptions();
        this.insurancePgaeOptions.sizePage = 15;
        this.professionalPageOptions = new PageOptions();
        this.firmPageOptions = new PageOptions();
        this.firmPageOptions.sizePage = 15;
        this.performerPageOptions = new PageOptions();
        this.procedurePageOptions = new PageOptions();
        this.procedurePageOptions.sizePage = 15;
        this.patientPageOptions = new PageOptions();
        this.cidPageOptions = new PageOptions();
        this.cidPageOptions.sizePage = 15;
        this.orderPayPageOptions = new PageOptions();
        this.companyPgaeOptions = new PageOptions();
        this.specialityPageOptions = new PageOptions();
        this.planPageOptions = new PageOptions();
        this.planPageOptions.sizePage = 15;

        this.specialityPageOptions.fieldSort = "speciality.name";
        this.specialityPageOptions.sizePage = 15;
        this.patientPageOptions.fieldSort = "person.name";
        this.performerPageOptions.fieldSort = "professional.person.name";
        this.performerPageOptions.sizePage = 15;
        this.professionalPageOptions.fieldSort = "person.name";
        this.professionalPageOptions.sizePage = 15;
        this.pageOptions.fieldSort = "login";
        this.parameterList = JSON.parse(localStorage.getItem("system_params"));

        this.parameterQuestionOnLanck = this.parameterList.filter(
            (p) => p.name == ParameterNameEnum.QUESTION_ON_LACK,
        )[0];
    }

    ngOnInit(): void {
        this.osForm = this.createOsForm();

        this.itemOsForm = this.createItemOsForm();
        this.orderPayForm = this.createOrderPayForm();
        this.insurance = new Insurance();

        this.route.params.subscribe(async (params) => {
            if (
                this._router.url.endsWith("new") ||
                this._router.url.endsWith("novo")
            ) {
                this.loadingOs = true;
                this.selectedTabIndex = this.TAB_OS;

                await this.getPatientDetails(params["id"]);
                this.osHeaderForm = this.createOsHeaderForm();
                this.isNewOs = true;
                let scheduleOS = JSON.parse(localStorage.getItem("scheduleOs"));
                if (scheduleOS) {
                    this.addOrderSchedule(scheduleOS);
                } else {
                    this.addOrder();
                }
                return;
            } else {
                if (params["orderId"]) {
                    this.selectedTabIndex = this.TAB_OS;
                    this.osHeaderForm = this.createOsHeaderForm();
                    await this.getPatientDetails(params["patientId"]);
                    await this.getOrderById(params["orderId"]);
                } else if (params["id"]) {
                    await this.getPatientDetails(params["id"]);
                } else {
                    this._router.navigate(["operacional/recepcao/os"]);
                }
            }
        });
    }

    async getAlerts(order?: Order, index?) {
        let alertSearch = new AlertSearch();
        this.alertList = new Array<Alert>();
        this.alertCountindex = 0;
        if (order?.id) {
            alertSearch.index = index ? index : 3; // 3 para modulo de atendimento
            alertSearch.companyId = order.companyCostCenter?.company?.id;
            alertSearch.insuranceId = order.insurance?.id;
            alertSearch.insurancePLanId = order.plan?.id;
            alertSearch.patientId = order.patient?.id;
        } else {
            alertSearch.index = index ? index : 3;
            alertSearch.companyId = this.companyControl?.value?.id;
            alertSearch.insuranceId =
                this.osHeaderForm.controls["insuranceHeaderOs"]?.value?.id;
            alertSearch.insurancePLanId =
                this.osHeaderForm.controls["planHeaderOs"]?.value?.id;
            alertSearch.patientId = this.patient?.id;
        }

        this.alertListProvider.getFindModule(alertSearch).then(async (res) => {
            if (res.body.length > 0) {
                this.alertList = res.body;
                await new Promise((resolve) => setTimeout(resolve, 100));
                this.showAlert();
            } else {
                this.alertCountindex = null;
            }
        });
    }

    async prepareAlert() {
        this.alertCountindex++;
        await new Promise((resolve) => setTimeout(resolve, 100));
        this.showAlert();
    }

    showAlert() {
        if (this.alertCountindex < this.alertList.length) {
            const dialog = this._matDialog.open(AlertModalComponent, {
                data: this.alertList[this.alertCountindex].content,
                panelClass: "clearPadding",
                height: "80%",
                width: "80%",
                disableClose: true,
            });
            dialog.afterClosed().subscribe({
                next: (res) => {
                    this.prepareAlert();
                    dialog.close();
                },
            });
        } else {
            this.alertCountindex = null;
        }
    }

    registrationSolic() {
        let value = {
            order: this.order,
            solic: this.professionalSolicControl?.value,
        };
        this.solicRegistrationDialogRef = this._matDialog.open(
            QuickRegistrationSolicComponent,
            {
                panelClass: "clearPadding",
                data: value,
                disableClose: false,
            },
        );

        this.solicRegistrationDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.professionalSolicControl.setValue(result);
                this.firmSolicControl.setValue(result.firm);
                this.typeProfessionalSolicControl.setValue(
                    result.staff ? "Interno" : "Externo",
                );
            }
        });
    }

    registrationFirm() {
        const dialog = this._matDialog.open(QuickRegistrationFirmComponent, {
            panelClass: "clearPadding",
            disableClose: false,
            width: "50%",
        });

        dialog.afterClosed().subscribe((result) => {
            if (result) {
                if (result.id) {
                    this.firmSolicControl.setValue(result);
                }
            }
        });
    }

    async getList() {
        if (!this.order.id) {
            await this.getTypeSurvey();
            this.getInsuranceList();
            this.getProfessionalList();
            this.getCids();
            this.getFirmList();
            this.getCompanyList();
        }
        this.getPayTypeList();
        // this.getCompanyCostCenter();
    }

    ngAfterViewInit() {
        this.loading = false;
        this.rolePermissionService
            .rolePermissions("operational-reception-os-edit")
            .then(() => {
                setTimeout(() => { }, 500);
            });

        this.rolePermissionService.formEvent
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((formGroup) => {
                if (formGroup) {
                    this.retrictionsFormFields = formGroup;
                    setTimeout(() => {
                        formGroup.forEach((formField: any) => {
                            if (formField.restrictionType === "H") {
                                $("#" + formField.code).hide();
                                $("#" + formField.code).prop("disabled", true);
                                // save form field name for future check
                            } else if (formField.restrictionType === "D") {
                                $("#" + formField.code).show();
                                $("#" + formField.code).prop("disabled", true);
                                if (
                                    formField.name === "company" &&
                                    formField.restriction == true
                                ) {
                                    this.companyControl.disable();
                                } else if (
                                    formField.name === "company" &&
                                    formField.restriction == false
                                ) {
                                    this.companyControl.enable();
                                }
                                if (
                                    formField.name === "firm" &&
                                    formField.restriction == true
                                ) {
                                    this.firmSolicControl.disable();
                                } else if (
                                    formField.name === "firm" &&
                                    formField.restriction == false
                                ) {
                                    this.firmSolicControl.enable();
                                }
                                // save form field name for future check
                            } else if (formField.restrictionType == null) {
                                $("#" + formField.code).show();
                                $("#" + formField.code).prop("disabled", false);
                            }

                            if (formField.restriction) {
                                const controls = this.osHeaderForm?.get(
                                    formField.name,
                                );
                                if (controls) {
                                    this.osHeaderForm.controls[
                                        formField.name
                                    ].disable();
                                }
                            } else {
                                const controls = this.osHeaderForm?.get(
                                    formField.name,
                                );
                                if (controls) {
                                    this.osHeaderForm.controls[
                                        formField.name
                                    ].enable();
                                }
                            }
                        });
                    }, 500);
                }
            });

        // this.getState(this.order.state);
        // this.getStateColor(this.order.state)
    }

    get unsubscribeAll() {
        return this._unsubscribeAll;
    }

    checkDefaulters() {
        this.AttendanceListProvider.checkDefaulters().then((res) => {
            if (res.body?.data == "DEFAULTERS" || res.body?.data == "BLOCKED") {
                this.showDialog(res.body?.data);
            }
        });
    }

    async showDialog(statusClient: string) {
        return new Promise((resolve, reject) => {
            const dialogRef = this._matDialog.open(ModalDefaultersComponent, {
                height: "70%",
                maxHeight: "70%",
                width: "50%",
                maxWidth: "50%",
                panelClass: "clearPadding",
                disableClose: true,
            });
            dialogRef.componentInstance.status = statusClient;
            dialogRef.afterClosed().subscribe((result) => {
                this.confirmDefaulter();
                resolve(result);
            });
        });
    }
    confirmDefaulter() {
        this.attendanceListProvider.confirmdefaulters().then(() => { });
    }

    getSession(event) {
        this.session = event;
    }

    ngOnDestroy(): void {
        $("html, body").animate({
            scrollTop: 0,
        });
        $(document).off();
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
        this.refreshService.refreshOrderPayPending();
    }

    @HostListener("window:beforeunload", ["$event"])
    onBeforeUnload(event: BeforeUnloadEvent): void {
        if (this.hasOpenPaymentPending()) {
            event.preventDefault();
            event.returnValue = this.openPaymentPendingMessage;
        }
    }

    canDeactivate(): Promise<boolean> {
        return this.confirmLeaveWithOpenPayment();
    }

    private confirmLeaveWithOpenPayment(): Promise<boolean> {
        return new Promise((resolve) => {
            if (!this.hasOpenPaymentPending()) {
                resolve(true);
                return;
            }

            this.confirmDialogRef = this._matDialog.open(
                FuseConfirmDialogComponent,
                {
                    disableClose: false,
                },
            );
            this.confirmDialogRef.componentInstance.action = "confirm";
            this.confirmDialogRef.componentInstance.confirmMessage =
                this.openPaymentPendingMessage;
            this.confirmDialogRef.componentInstance.textButtonConfirm = "Sair";
            this.confirmDialogRef.componentInstance.textButtonCancel =
                "Permanecer";
            this.confirmDialogRef.afterClosed().subscribe((confirm) => {
                const canLeave = confirm === true;

                if (!canLeave) {
                    this.openPaymentPendingTab();
                }

                resolve(canLeave);
            });
        });
    }

    private openPaymentPendingTab(): void {
        this.setMainTab(this.TAB_OS);
        this.selectedTabInfoOrderIndex = this.TAB_INFO_ORDER_PAYMENT;
        this.filterFormPay();
        this.scrollIntoView();
    }

    private setMainTab(tab: number): void {
        this.updatingMainTab = true;
        this.selectedTabIndex = tab;

        if (this.tabGroup) {
            this.tabGroup.selectedIndex = tab;
        }

        this.cdr.detectChanges();
        setTimeout(() => {
            this.updatingMainTab = false;
        });
    }

    private hasOpenPaymentPending(): boolean {
        return (
            this.getPaymentMissingValue() > 0 &&
            !this.isPaymentTabDisabled()
        );
    }

    isPaymentTabDisabled(): boolean {
        const paymentModel = this.order?.insurance?.paymentModel;

        return (
            this.isAdvancePaymentOrder ||
            (paymentModel !== "P" && paymentModel !== "O")
        );
    }

    private getPaymentMissingValue(): number {
        const missingValue = this.orderPayMissing as any;

        if (typeof missingValue === "number") {
            return missingValue;
        }

        if (missingValue == null || missingValue === "") {
            return 0;
        }

        const normalizedValue = String(missingValue)
            .replace(/\./g, "")
            .replace(",", ".");

        return Number(normalizedValue) || 0;
    }

    getUserList() {
        this.userListProvider.getPage(this.pageOptions).then((res) => {
            this.userList = res.body.content;
        });
    }

    displayFn(user) {
        if (user) {
            return user.login;
        }
    }
    displayGenericFn(object?: any): string | undefined {
        if (!object) {
            return "";
        }
        return object.name ? object.name : "";
    }

    getState(state) {
        let result = "";
        switch (state) {
            case "N":
                result = "Normal";
                break;
            case "B":
                result = "Bloqueada";
                break;
            case "P":
                result = "Pendente";
                break;
            case "C":
                result = "Cancelada";
                break;
            default:
                break;
        }
        this.orderState = result;
        return result;
    }
    getStatus(status) {
        let result = "";
        switch (status) {
            case "1":
                result = "Aberta";
                break;
            case "2":
                this.blockOs();
                result = "Fechada";
                break;

            default:
                break;
        }
        this.orderStatus = result;
        return result;
    }
    getStateColor(state) {
        switch (state) {
            case "N":
                this.stateColor = "#418bcbc2";
                break;
            case "B":
                this.stateColor = "rgb(65 139 203 / 92%)";
                break;
            case "P":
                this.stateColor = "#e9403b";
                break;
            case "C":
                this.stateColor = "#e9403b";
                break;
            default:
                break;
        }
    }

    blockOs() {
        if (this.order.id && this.osForm instanceof FormGroup) {
            this.osForm.disable();
            this.osForm.controls["validity"].enable();
            this.osForm.controls["registration"].enable();
        }
        if (this.osHeaderForm instanceof FormGroup) {
            this.osHeaderForm.disable();
            this.osHeaderForm.controls["planHeaderOs"].enable();
            this.osHeaderForm.controls["numberHeaderOs"].enable();
            this.osHeaderForm.controls["statusHeaderOs"].enable();
            this.osHeaderForm.controls["enrollment"].enable();
        }
        this.lockCheck.disable();
        this.companyControl.disable();
        this.cidFormControl.disable();

        this.orderPayForm.disable();
        this.disableDeleteOrderPay = true;
        this.disableDeleteOrderItem = true;
    }

    cancelOrderItem(orderItem) {
        this.attendanceEditProvider.cancelOrderItem(orderItem).then((res) => {
            // this.getOrderItemList(this.order.id);
            this.getOrderById(this.order.id);
        });
    }

    undoCancelOrderItem(orderItem) {
        this.attendanceEditProvider
            .undoCancelOrderItem(orderItem)
            .then((res) => {
                this.getOrderItemList(this.order.id);
            });
    }

    lockOrUnlockOrCancelOrder(type) {
        if (type === "CANCEL" && this.isAdvancePaymentOrder) {
            return;
        }

        switch (type) {
            case "LOCK":
                this.attendanceEditProvider
                    .lockOrder(this.order.id, "ORDER")
                    .then((res) => {
                        this.navigateChangeStatus();
                    });
                break;
            case "UNLOCK":
                this.attendanceEditProvider
                    .unlockOrder(this.order.id, "ORDER")
                    .then((res) => {
                        this.navigateChangeStatus();
                    });
                break;
            case "CANCEL":
                this.attendanceEditProvider
                    .cancelOrder(this.order.id)
                    .then((res) => {
                        this.navigateChangeStatus();
                    });
                break;
            case "UNCANCEL":
                this.attendanceEditProvider
                    .unCancelOrder(this.order.id)
                    .then((res) => {
                        this.navigateChangeStatus();
                    });
                break;
            case "OPEN":
                this.attendanceEditProvider
                    .openOrder(this.order.id)
                    .then((res) => {
                        this.navigateChangeStatus();
                    });
                break;
            case "CLOSE":
                this.attendanceEditProvider
                    .closeOrder(this.order.id)
                    .then((res) => {
                        this.navigateChangeStatus();
                    });
                break;

            default:
                break;
        }
    }

    navigateChangeStatus() {
        if (this._router.url.includes("/editar")) {
            this._router.navigate([
                `operacional/recepcao/os/manter/${this.patient.id}/${this.order.id}`,
            ]);
        } else {
            this._router.navigate([
                `operacional/recepcao/os//manter/${this.patient.id}/${this.order.id}/editar`,
            ]);
        }
    }

    clear() {
        this.viewRegister = false;
        this.osForm.reset();
        this.osForm.controls["userId"].setValue("");
        this.pageOptions.argument = "";
        this.osForm.updateValueAndValidity();
    }

    viewFilterMode() {
        let fields = this.osForm.get("auditFilterFields") as FormArray;
        while (fields.length !== 1) {
            fields.removeAt(1);
        }
        fields.reset();

        this.osForm.controls["userId"].setValue("");
        this.pageOptions.argument = "";
        this.osForm.updateValueAndValidity();

        // this.search();
    }

    addField(i) {
        let fields = this.osForm.get("auditFilterFields") as FormArray;
        if (fields.controls[i].valid) {
            const data: Array<any> = fields.getRawValue();
            fields.push(this.fieldForm());
        } else {
            this.snackBar.errorMessage("Verifique o(s) campo(s) em destaque");
        }
    }

    removeField(i) {
        let fields = this.osForm.get("auditFilterFields") as FormArray;
        if (fields.length > 1) {
            fields.removeAt(i);
        } else {
            fields.controls[i].reset();
        }
    }

    fieldForm() {
        return this._formBuilder.group({
            name: this._formBuilder.control(null),
            value: this._formBuilder.control(null),
        });
    }

    createOsForm(): FormGroup {
        let date = new Date();
        return this._formBuilder.group({
            patient: [null],
            dateOs: [date],
            hourStart: [null],
            hourEnd: [null],
            insurance: [null, Validators.required],
            registration: [null],
            guideNumber: [null],
            seq: [null],
            dateInvoice: [date],
            lot: [null],
            datePayment: [date],
            validity: [null],
            product: [null],
            plan: [null],
            holder: [null],
            procedure: [null],
            professional: [null],
            professionalPercentage: [null],
            via: [null],
            technique: [null],
            qtd: [null],
            desc: [null],
            value: [null],
            resultCenter: [null],
            attendanceType: [null],
            professionalRequest: [null],
            cid: [null],
            osNumber: [null],
            pendency: [null],
            professionalAccredited: [null],
            speciality: [null],
            local: [null],
            type: [null],
            anesthetist: [null],
            equipment: [null],
            attendanceNumber: [null],
            requester: [null],
            operation: [null],
            nightAdditional: [null],
            chargeService: [null],
            spontaneousDemand: [null],
            cns: [null],
            cpf: [null],
            birthday: [null],
            gender: [null],
            medicalRecord: [null],
            email: [null],
            tel: [null],
            city: [null],
            lastAttendance: [null],
            lastSchedule: [null],
        });
    }

    createOsHeaderForm(): FormGroup {
        let date = new Date();
        return this._formBuilder.group({
            numberHeaderOs: [null, Validators.maxLength(25)],
            dateHeaderOs: [date, Validators.required],
            hourHeaderOs: [null, Validators.required],
            attendanceTypeHeaderOs: [null, Validators.required],
            insuranceHeaderOs: [null, Validators.required],
            mainProfessionalHeaderOs: [null, Validators.required],
            mainItemHeaderOs: [
                null,
                [Validators.required, RequireMatch.bind(this)],
            ],
            enrollment: [null],
            planHeaderOs: [null],
            stateHeaderOs: ["NLL"],
            resultCenterHeaderOs: [null, Validators.required],
            statusHeaderOs: [null, Validators.required],
            cidHeaderOs: [null],
            typeHeaderOs: [null, Validators.required],
            value: [null],
            quantity: ["1"],
        });
    }

    generateNewNumberOrder() {
        this.snackBar.successMessage(
            "Gerando nova numeração de guia, aguarde...",
        );
        this.loadingGenerateNumber = true;
        this.loading = true;
        this.attendanceEditProvider
            .generateNewNumberOrder(this.order?.id)
            .then((res) => {
                this.loadingGenerateNumber = false;
                this.navigateChangeStatus();
            })
            .catch((err) => {
                this.loadingGenerateNumber = false;
                this.loading = false;
            });
    }

    createItemOsForm(): FormGroup {
        let date = new Date();
        return this._formBuilder.group({
            launcherType: [null, Validators.required],
            dateItemOs: [date, Validators.required],
            resultCenterItemOs: [null, Validators.required],
            profissionalRequest: [null, Validators.required],
        });
    }

    memoryCalc() {
        if (!this.order?.id) {
            return;
        }
        this.AttendanceListProvider.getMemoryCalc(this.order.id).then((res) => {
            if (res.body.data?.length > 0) {
                let dialog = this._matDialog.open(DialogMemoryCalcComponent, {
                    disableClose: false,
                    panelClass: "clearPadding",
                    height: "90%",
                    maxHeight: "90%",
                    width: "90%",
                    maxWidth: "90%",
                });
                dialog.componentInstance.dataSource = res.body.data;
                dialog
                    .afterClosed()
                    .pipe(takeUntil(this._unsubscribeAll))
                    .subscribe({
                        next(value) {
                            dialog = null;
                        },
                    });
            }
        });
    }
    displayPatientFn(patient?: any): string | undefined {
        if (!patient) {
            return "";
        }
        return patient.person ? patient.person.name : patient;
    }

    displayFirmFn(firm?: any): string | undefined {
        if (!firm) {
            return "";
        }
        return firm.name ? firm.name : "";
    }

    displayPerformerFn(performer?: any): string | undefined {
        if (!performer) {
            return "";
        }
        if (performer.professional) {
            return performer.professional.person.name;
        }
        return performer.person.name;
    }

    displayCIDFn(cid?: any): string | undefined {
        if (!cid) {
            return "";
        }
        return `${cid.tableName} - ${cid.code}`;
    }

    displaySimpleFn(object?: any): string | undefined {
        if (object && object.name) {
            return object.name;
        } else if (object && object.tableName) {
            return object.tableName;
        } else {
            return "";
        }
    }

    displayCompanyCostCenterFn(object?: any): string | undefined {
        if (object && object.costCenter.name) {
            return object.costCenter.name;
        } else {
            return "";
        }
    }

    getPatientList() {
        this.patientListProvider
            .getPage(this.patientPageOptions)
            .then((res) => {
                this.patientList = res.body.content;
            });
    }

    async getPatientDetails(id) {
        return new Promise((resolve, reject) => {
            this.patientListProvider.getSimpleObjById(id).subscribe({
                next: (res) => {
                    if (res && res.body !== null) {
                        this.patient = res.body;
                        this.handleAttendance();
                        // this.showImg();
                        // this.addOrderSchedule();
                        //if (this.patient.insurance?.id) {
                        //  this.getParametersInsurance(
                        //    this.patient.insurance.id,
                        //);
                        //}
                        this.patientPlanList = [this.patient.plan];
                        setTimeout(() => {
                            this.checkFilledsDocs();
                        }, 1000);
                    }
                    this.getParameterValueserviceFrequencyPerWeek(id);
                    resolve(true);
                },
                error(err) {
                    reject(false);
                },
            });
        });
    }

    cidRemove(cid) {
        let cidIindex;
        this.cidListSelected.forEach((item, index) => {
            if (item.cid.id === cid.cid.id) {
                cidIindex = index;
                return;
            }
        });
        this.cidListSelected.splice(cidIindex, 1);
        if (cid.main == true) {
            this.cidListSelected[0].main = true;
        }

        //
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || "").trim();

        if (value) {
            this.cidListSelected.push(value);
        }

        event.chipInput!.clear();

        this.cidFormControl.setValue(null);
    }

    cidMain(cid) {
        this.cidListSelected.forEach((item) => {
            if (item.cid.id === cid.cid.id) {
                item.main = true;
            } else {
                item.main = false;
            }
        });
    }

    cidSelected(cid) {
        let cidDiagnosis = new OrderDiagnosis();
        let exist = false;
        cidDiagnosis.cid = cid.option.value;

        if (this.cidListSelected.length) {
            this.cidListSelected.forEach((cidFromList) => {
                if (cidFromList.cid.id == cidDiagnosis.cid.id) {
                    exist = true;
                }
            });
        }

        if (exist) {
            this.snackBar.warnMessage("Cid já Selecionado");
            return;
        } else {
            this.cidListSelected.push(cidDiagnosis);
        }
        this.cidListSelected.length == 1
            ? (this.cidListSelected[0].main = true)
            : "";
        this.cidInput.nativeElement.value = "";
        this.cidFormControl.setValue(null);
    }

    // TODO - Rafael (destruir datasource)
    changePatient() {
        this.dataSource.disconnect();
    }
    handlePatientEdit() {
        this._router.navigate([
            "cadastro/operacional/paciente/manter/" +
            this.patient.id +
            "/editar",
        ]);
    }

    showImg(content) {
        if (content) {
            this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl(
                "data:image/jpg;base64," + content,
            );
        } else {
            this.imagePath = null;
        }
    }

    checkFilledsDocs() {
        this.showImg(this.patient?.person?.photoMain);
    }

    action(action) {
        switch (action) {
            case "back":
                this.isNewItemOs = false;
                break;
            case "new":
                this.detailsOrderItem({ order: this.order.id });
                break;
            case "SAVE_ITEM":
                this.saveItem = true;

                break;
            case "SAVE_ITEM_CLOSED":
                this.saveItem = false;

                break;
            case "backOrderPay":
                this.isDetailsPayment = !this.isDetailsPayment;
            default:
                break;
        }
    }

    //Verifica o tipo de lançamento
    typeAttendance() {
        this.osHeaderForm.controls["typeHeaderOs"].valueChanges.subscribe(
            (res) => {
                if (res != 1) {
                    this.isProcedure = false;
                } else {
                    this.isProcedure = true;
                }
            },
        );
    }

    filterInsurance() {
        this.osHeaderForm.controls["insuranceHeaderOs"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(600),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (res && res.id) {
                    if (res.paymentModel === "T") {
                        this.osHeaderForm.controls["enrollment"].addValidators([
                            Validators.required,
                        ]);
                    } else {
                        this.osHeaderForm.controls[
                            "enrollment"
                        ].clearValidators();
                    }
                    if (this.alertCountindex == null) {
                        this.getAlerts();
                    }

                    this.getProcedurePerfomerByInsurance(res);
                    if (res.id != this.patient.insurance.id && !this.order.id) {
                        this.osHeaderForm.controls["planHeaderOs"].setValue(
                            null,
                        );
                        this.setMainPlan(null);
                        this.osHeaderForm.controls["enrollment"].setValue(null);
                    }

                    this.getParametersInsurance(res.id);
                    this.insurance = res;
                    setTimeout(() => {
                        this.initKit("new");
                    }, 500);
                } else if (res && typeof res == "string") {
                    this.insurancePgaeOptions.argument = res;
                } else {
                    this.insurancePgaeOptions.argument = "";
                    this.osHeaderForm.controls["insuranceHeaderOs"].setValue(
                        null,
                    );
                    this.procedureList = [];
                    this.insurance = new Insurance();
                }
                this.cdr.detectChanges();
                this.getInsuranceList();
            });
    }

    //procedure
    filterProcedure() {
        this.osHeaderForm.controls["mainItemHeaderOs"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(600),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (typeof res === "string") {
                    this.procedurePageOptions.argument = res;
                } else if (res && res.id) {
                    this.accreditationKitList = new Array();
                    this.kitList = new Array();
                    this.procedurePageOptions.argument = res.name || "";
                    this.getPerformerByInsuranceAndProcedure(res.id);
                } else {
                    this.accreditationKitList = new Array();
                    this.kitList = new Array();
                    this.procedurePageOptions.argument = "";
                    this.osHeaderForm.controls["mainItemHeaderOs"].setValue("");
                    this.getPerformerByInsuranceAndProcedure();
                }
                this.getProcedureListByInsurance();
            });
    }

    // filtro para o cid
    filterCid() {
        this.cidFormControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (res && res.id) {
                    this.cidPageOptions.argument = res.name;
                } else if (res && typeof res === "string") {
                    this.cidPageOptions.argument = res;
                } else {
                    this.cidPageOptions.argument = "";
                    this.osHeaderForm.controls["cidHeaderOs"].setValue(null);
                }

                this.getCids();
            });
    }

    filterPerformer() {
        this.osHeaderForm.controls["mainProfessionalHeaderOs"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(600),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                this.specialityList = [];
                if (res && res.id) {
                    this.mainProfissional = res;
                    this.getSpeciality(res.professional.id);
                    this.performerPageOptions.argument =
                        res.professional.person.name;
                    this.getProcedureListByInsurance();
                } else if (res && typeof res === "string") {
                    this.performerPageOptions.argument = res;
                    this.specialityControl.setValue(null);
                } else {
                    this.mainProfissional = null;
                    this.specialityControl.setValue(null);
                    this.specialityList = [];
                    this.getProcedureListByInsurance();
                    this.performerPageOptions.argument = "";
                    this.osHeaderForm.controls[
                        "mainProfessionalHeaderOs"
                    ].setValue(null);
                }
                this.getPerformerByInsuranceAndProcedure();
            });
    }

    filterProfessional() {
        this.itemOsForm.controls["profissionalRequest"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(600),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                this.filterMethodProfessional(res);
                this.getProfessionalList();
            });
    }

    filterMethodProfessional(res) {
        if (res && res.id) {
            this.professionalPageOptions.argument = res.performer.name;
        } else if (res) {
            this.professionalPageOptions.argument = res;
        } else {
            this.professionalPageOptions.argument = "";
            this.itemOsForm.controls["profissionalRequest"].setValue(null);
        }
    }
    getSpeciality(professionalInputId?) {
        let professionalId: number;
        if (professionalInputId) {
            professionalId = professionalInputId;
        } else {
            professionalId =
                this.osHeaderForm.controls["mainProfessionalHeaderOs"].value
                    ?.professional?.id;
        }

        if (!professionalId) {
            return;
        }

        this.attendanceListProvider
            .getSpeciality(professionalId, this.specialityPageOptions)
            .then((res) => {
                if (this.specialityList.length == 0) {
                    this.specialityList = res.body.content;
                    this.specialityControl.setValue(this.specialityList[0], {
                        emitEvent: false,
                    });
                } else {
                    this.specialityList = res.body.content;
                }
            });
    }

    filterSpeciality() {
        this.specialityControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(600),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                let filter = "";
                if (res && typeof res === "string") {
                    filter = res;
                }
                this.specialityPageOptions.argument = filter;
                this.getSpeciality();
            });
    }

    initFilters() {
        this.filterInsurance();
        this.filterPerformer();
        this.filterProcedure();
        this.filterProfessional();
        this.filterCid();
        this.typeAttendance();
        this.filterFirm();
        this.filterSpeciality();
        // this.filterFormPay();
        this.observableQuantity();
        this.filterCompany();
        this.observablePlan();
        this.getParameterValue(ParameterNameEnum.CONTROL_SESSION, "");
        if (!this.order?.id) {
            this.filterProfessionalNew();
        }
    }

    filterFirm() {
        this.firmSolicControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(600),
                distinctUntilChanged(),
            )
            .subscribe({
                next: (res) => {
                    let filter = "";
                    if (typeof res === "string") {
                        filter = res;
                    }
                    this.firmPageOptions.argument = filter;
                    this.getFirmList();
                },
            });
    }

    filterProfessionalNew() {
        this.professionalSolicControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(600),
                distinctUntilChanged(),
            )
            .subscribe({
                next: (res) => {
                    if (typeof res == "string") {
                        this.professionalPageOptions.argument = res;
                    } else {
                        this.professionalPageOptions.argument = "";
                    }
                    if (res?.id) {
                        this.firmSolicControl.setValue(res.firm);
                        this.typeProfessionalSolicControl.setValue(
                            res.staff ? "Interno" : "Externo",
                        );
                        if (res.staff) {
                            this.firmSolicControl.clearValidators();
                            this.firmSolicControl.updateValueAndValidity();
                        } else {
                            this.firmSolicControl.setValidators(
                                Validators.required,
                            );
                            this.firmSolicControl.updateValueAndValidity();
                        }
                    }

                    this.getProfessionalList();
                },
            });
    }

    filterCompany() {
        this.companyControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(600),
                distinctUntilChanged(),
            )
            .subscribe({
                next: (response) => {
                    if (response?.id) {
                        if (this.companySelectd?.id == null) {
                            this.companySelectd = response;
                        } else if (this.companySelectd?.id != response.id) {
                            this.osHeaderForm.controls[
                                "resultCenterHeaderOs"
                            ].setValue("");
                            this.companySelectd = response;
                        }
                        this.getProcedureListByInsurance();
                    }
                    if (response && typeof response == "string") {
                        this.companyPgaeOptions.argument = response;
                        this.getCompanyList();
                    }
                    if (this.order?.id) {
                        this.osHeaderForm.controls[
                            "resultCenterHeaderOs"
                        ].setValue(null);
                    }
                },
            });
    }

    observableQuantity() {
        this.osHeaderForm.controls["quantity"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(300),
                distinctUntilChanged(),
            )
            .subscribe({
                next: (res) => {
                    if (res > 1) {
                        this.sessionView = this.ControlSessionByParameterSystem
                            ? this.ControlSessionByParameterSystem
                            : this.ControlSessionByParameterProcedure;
                    } else {
                        this.sessionView = false;
                    }
                    this.quatitySessionCurrent = res;
                },
            });
    }

    handleOsHeader(schedule?: Schedule) {
        this.progress = true;
        if (this.osHeaderForm instanceof FormGroup) {
            if (this.patient && this.patient.person) {
                this.osHeaderForm.controls["numberHeaderOs"].setValue(
                    this.order.number,
                    { EventEmitter: false },
                );
                this.osHeaderForm.controls["dateHeaderOs"].setValue(
                    this.order.date,
                );
                this.osDate = moment(this.order.date);
                this.osHeaderForm.controls["hourHeaderOs"].setValue(
                    this.order.hour,
                );
                this.osHeaderForm.controls["attendanceTypeHeaderOs"].setValue(
                    this.order.exameType,
                );

                if (this.order.id) {
                    this.osHeaderForm.controls["insuranceHeaderOs"].setValue(
                        this.order.insurance,
                        { emitEvent: false },
                    );
                    this.osHeaderForm.controls["planHeaderOs"].setValue(
                        this.order.plan,
                        { emitEvent: false },
                    );
                    this.osHeaderForm.controls["enrollment"].setValue(
                        this.order.enrollment,
                        { emitEvent: false },
                    );
                    this.osHeaderForm.controls["statusHeaderOs"].setValue(
                        this.order.status,
                        { emitEvent: false },
                    );
                    this.companyControl.setValue(
                        this.order.companyCostCenter.company,
                        { emitEvent: false },
                    );
                    this.companySelectd = this.order.companyCostCenter.company;
                    this.osHeaderForm.controls["resultCenterHeaderOs"].setValue(
                        this.order.companyCostCenter,
                        { emitEvent: false },
                    );
                    this.osHeaderForm.controls["mainItemHeaderOs"].setValue(
                        this.order.mainProcedure,
                        { emitEvent: false },
                    );
                    this.osHeaderForm.controls[
                        "mainProfessionalHeaderOs"
                    ].setValue(this.order.mainPerformer, { emitEvent: false });
                    this.osHeaderForm.controls["value"].setValue(
                        this.order.value,
                    );
                    this.userCreatedControl.setValue(this.order.userCreated);
                    this.userUpdatedControl.setValue(this.order.userUpdated);
                    if (this.order.validatyEnrollment != null) {
                        this.snackBar.notifierMessage(
                            "simpleMessage",
                            "Informativo",
                            [this.order.validatyEnrollment],
                        );
                    }
                    this.insurance = this.order.insurance;
                    this.getPlanList();
                } else if (schedule) {
                    this.insurance = schedule.insurance;
                    if (schedule.insurance.id == this.patient.insurance?.id) {
                        this.osHeaderForm.controls[
                            "insuranceHeaderOs"
                        ].setValue(this.patient.insurance, { eventEmit: true });
                        this.osHeaderForm.controls["planHeaderOs"].setValue(
                            this.patient.plan,
                        );
                        this.osHeaderForm.controls["enrollment"].setValue(
                            this.patient.enrollment,
                        );
                        this.setMainPlan(this.patient.plan);
                    } else {
                        this.osHeaderForm.controls[
                            "insuranceHeaderOs"
                        ].setValue(schedule.insurance, { eventEmit: true });

                        this.osHeaderForm.controls["planHeaderOs"].setValue(
                            null,
                        );

                        if (this.osForm.controls["insurance"].value == null) {
                            this.osForm.controls["insurance"].setValue(
                                this.insurance,
                            );
                        }
                    }

                    // this.companyControl.setValue(schedule.company);
                    // this.getCompanyCostCenter(schedule.company);

                    this.companySelectd = schedule.company;
                    this.osHeaderForm.controls[
                        "mainProfessionalHeaderOs"
                    ].setValue(schedule.performer);
                    this.getSpeciality(schedule.performer.professional.id);
                    this.osHeaderForm.controls["mainItemHeaderOs"].setValue(
                        schedule.procedure,
                    );
                    //                   this.handleProceduleSelected(schedule.procedure.id);
                    this.mainProfissional = schedule.performer;
                    this.getParametersInsurance(schedule.insurance.id);
                } else {
                    this.osHeaderForm.controls["insuranceHeaderOs"].setValue(
                        this.patient.insurance,
                    );
                    this.osHeaderForm.controls["planHeaderOs"].setValue(
                        this.patient.plan,
                    );
                    this.setMainPlan(this.patient.plan);
                    this.osHeaderForm.controls["enrollment"].setValue(
                        this.patient.enrollment,
                    );
                    this.insurance = this.patient.insurance;
                }
                this.osHeaderForm.controls["stateHeaderOs"].setValue(
                    this.order.state || "N",
                );
                if (this.order.state) {
                    // const checkState = this.order.state.split('');
                    if (this.order.state == "B") {
                        this.lockCheck.setValue(true);
                    } else {
                        this.lockCheck.setValue(false);
                    }
                } else {
                    this.lockCheck.setValue(false);
                }

                if (this.osHeaderForm.controls["insuranceHeaderOs"].value?.id) {
                    this.getParametersInsurance(
                        this.osHeaderForm.controls["insuranceHeaderOs"].value
                            ?.id,
                    );
                }
                if (this.osHeaderForm.controls["insuranceHeaderOs"].value?.id) {
                    this.getParametersInsurance(
                        this.osHeaderForm.controls["insuranceHeaderOs"].value
                            ?.id,
                    );
                }

                this.exameTypeSelected = this.order.exameType;
                this.progress = false;
            } else {
                this.osHeaderForm.reset();
                this.progress = false;
            }
        }
    }

    handleAttendance() {
        if (this.osForm instanceof FormGroup) {
            if (this.patient && this.patient.person) {
                this.osForm.controls["patient"].setValue(
                    this.patient.person.name,
                );
                this.osForm.controls["cns"].setValue(this.patient.person.cns);
                this.osForm.controls["cpf"].setValue(this.patient.person.cpf);
                this.osForm.controls["birthday"].setValue(
                    this.patient.person.birthday,
                );
                this.osForm.controls["gender"].setValue(
                    this.patient.person.gender
                        ? this.patient.person.gender.name
                        : "",
                );
                this.osForm.controls["city"].setValue(
                    this.patient.person.address
                        ? this.patient.person.address.city.name
                        : "",
                );

                this.osForm.controls["insurance"].setValue(
                    this.patient.insurance,
                );
                this.osForm.controls["medicalRecord"].setValue(
                    this.patient.medicalRecord,
                );
                this.osForm.controls["registration"].setValue(
                    this.patient.enrollment,
                );
                this.osForm.controls["desc"].setValue(0.0);
                this.osForm.controls["qtd"].setValue(1);
                this.osForm.controls["local"].setValue(1);
                this.osForm.controls["type"].setValue(1);
                this.osForm.controls["nightAdditional"].setValue(false);
                this.osForm.controls["chargeService"].setValue(true);
                this.osForm.controls["spontaneousDemand"].setValue(true);

                this.osForm.controls["plan"].setValue(
                    this.patient.plan ? this.patient.plan : null,
                );
                this.osForm.controls["validity"].setValue(
                    this.patient.validity,
                );
                this.osForm.controls["product"].setValue(this.patient.product);
                this.osForm.controls["holder"].setValue(this.patient.holder);

                if (
                    this.patient.person.contactList &&
                    this.patient.person.contactList.contactItem.length
                ) {
                    let email =
                        this.patient.person.contactList.contactItem.filter(
                            (m) => m.type === "M",
                        );
                    let phone =
                        this.patient.person.contactList.contactItem.filter(
                            (m) => m.type === "S",
                        );
                    this.osForm.controls["email"].setValue(
                        email.length > 0 ? email[0].email : "",
                    );
                    this.osForm.controls["tel"].setValue(
                        phone.length > 0 ? phone[0].phone : "",
                    );
                }

                //setar tipo e local default

                this.isRegister = true;
            } else {
                this.osForm.reset();
            }
        }
    }

    handelOs() {
        if (this.osHeaderForm instanceof FormGroup) {
            this.osHeaderForm.controls["planHeaderOs"].setValue(
                this.patient.plan.name,
            );
        }
    }

    checkFields() {
        let check = true;
        let osHeader = this.osHeaderForm.getRawValue();
        if (this.auxiliaryList && this.auxiliaryList.length > 0) {
            this.auxiliaryList.forEach((kit) => {
                if (!kit.performer) {
                    this.snackBar.warnMessage(
                        "Auxiliar sem o Profissonal Informando!",
                    );
                    check = false;
                }
            });
        }
        return check;
    }

    async saveAttendane() {
        if (this.saveItem == true) {
            return;
        }
        this.disabledSaveAttendance = true;
        this.progressBar.show();
        this.loading = true;
        let lack = await this.checkLack();
        if (lack == false) {
            this.disabledSaveAttendance = false;
            this.progressBar.hide();
            this.loading = false;
            return;
        }

        this.snackBar.successMessage("Salvando informações do atendimento")!;
        this.handleAttendanceSave()
            .then((res) => {
                this.disabledSaveAttendance = false;
                this.loading = false;
                this.progressBar.hide();
            })
            .catch(() => {
                this.disabledSaveAttendance = false;
                this.progressBar.hide();
                this.loading = false;
            });
    }

    async checkLack() {
        return new Promise((resolve, reject) => {
            let attendance = this.osHeaderForm.getRawValue();
            if (this.order?.id) {
                resolve(true);
                return;
            }
            let lack = new QuotaLackTO();
            lack.companyId = this.getValueOrNullOrUndefined(
                attendance?.resultCenterHeaderOs?.company?.id,
            );
            lack.insuranceId = this.getValueOrNullOrUndefined(
                attendance?.insuranceHeaderOs?.id,
            );
            lack.patientId = this.getValueOrNullOrUndefined(this.patient.id);
            lack.procedureId = attendance?.mainItemHeaderOs?.id
                ? attendance?.mainItemHeaderOs?.id
                : null;
            lack.date = attendance?.dateHeaderOs
                ? moment(attendance?.dateHeaderOs).format("YYYY-MM-DD")
                : null;
            lack.performerId = this.getValueOrNullOrUndefined(
                attendance?.mainProfessionalHeaderOs?.id,
            );
            lack.specialityId = this.getValueOrNullOrUndefined(
                this.specialityControl.value?.id,
            );
            lack.quantity = this.getValueOrNullOrUndefined(attendance.quantity);
            lack.context = "ORDER";
            let isAnyFieldNull = Object.values(lack).some(
                (value) => value === null,
            );

            if (isAnyFieldNull) {
                resolve(true);
            } else {
                this.quotaLackControlEditProvider
                    .checkQuotaLack(lack)
                    .then((res) => {
                        if (res.body == "success") {
                            resolve(true);
                        } else {
                            resolve(this.lackConfirm(res.body));
                        }
                    })
                    .catch((err) => {
                        resolve(false);
                    });
            }
        });
    }

    async lackConfirm(message) {
        return new Promise<any>((resolve, reject) => {
            let dialog = this._matDialog.open(FuseConfirmDialogComponent, {
                disableClose: true,
            });
            dialog.componentInstance.action = "confirm";
            dialog.componentInstance.confirmMessage = message;
            dialog.afterClosed().subscribe({
                next(value) {
                    if (value) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                },
            });
        });
    }

    async updateEnrollmentPatient() {
        this.confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: false,
            },
        );
        this.confirmDialogRef.componentInstance.action = "confirm";
        this.confirmDialogRef.afterClosed().subscribe(async (confirm) => {
            if (confirm) {
                let enrollment = this.osHeaderForm.controls["enrollment"].value;
                this.attendanceEditProvider
                    .updateEnrollmentPatient(
                        enrollment,
                        this.patient.id,
                        this.order.id,
                    )
                    .then((res) => { });
            }
        });
    }

    getValueOrNullOrUndefined(value: number): number {
        return value !== undefined && value !== null ? value : null;
    }

    async confirmNavigateOrderProcedureSchedule() {
        return new Promise<string>((resolve, reject) => {
            let dialog = this._matDialog.open(
                ScheduleDialogOsProcedureComponent,
                {
                    data: this.scheduleWhithChilden,
                    disableClose: false,
                    panelClass: "clearPadding",
                },
            );

            dialog
                .afterClosed()
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe({
                    next: (res: string) => {
                        resolve(res);
                    },
                });
        });
    }

    async handleAttendanceSave() {
        let typeSave: string = "N";
        if (this.scheduleWhithChilden?.length > 0) {
            typeSave = await this.confirmNavigateOrderProcedureSchedule();
        }
        if (this.osHeaderForm instanceof FormGroup) {
            if (!this.checkFields()) {
                this.progressBar.hide();
                this.loading = false;
                this.disabledSaveAttendance = false;
                return;
            }

            return new Promise(async (resolve, reject) => {
                try {
                    let attendance = this.osHeaderForm.getRawValue();
                    let patient = this.osForm.getRawValue();

                    let orderSave: Order = new Order();
                    orderSave.typeSave = typeSave;
                    orderSave.scheduleId = this.scheduleId;
                    orderSave.date =
                        typeof attendance.dateHeaderOs !== "string"
                            ? CwUtils.formatDate(
                                CwUtils.momentToDate(attendance.dateHeaderOs),
                                "Data da Guia",
                            )
                            : attendance.dateHeaderOs;
                    orderSave.hour = attendance.hourHeaderOs;
                    orderSave.exameType = this.exameType;
                    orderSave.companyCostCenter =
                        attendance.resultCenterHeaderOs;
                    // delete orderSave.companyCostCente
                    // if(!this.mainCostCenter?.id){
                    //     this.snackBar.warnMessage("Centro de resultado obrigatório")
                    //     return;
                    // }
                    // // orderSave.companyCostCenter = this.order.companyCostCenter;
                    // // orderSave.companyCostCenter.id = 1;
                    // orderSave.companyCostCenter.costCenter = this.mainCostCenter;
                    orderSave.patient = this.patient;
                    orderSave.insurance = this.insurance;
                    orderSave.status = attendance.statusHeaderOs;
                    orderSave.value =
                        attendance.value == null ? 0 : attendance.value;
                    orderSave.number = attendance.numberHeaderOs;
                    orderSave.quantity = attendance.quantity;

                    if (
                        this.session &&
                        this.session.quantity > 1 &&
                        this.session.frequency != null
                    ) {
                        orderSave.session = this.session;
                    }

                    if (this.order?.id) {
                        if (this.order.session?.id) {
                            orderSave.session = this.order.session;
                        }
                    }

                    let state: string;

                    if (this.lockCheck.value == true) {
                        state = "B";
                    } else if (
                        this.lockCheck.value == false &&
                        attendance.stateHeaderOs == "B"
                    ) {
                        state = "N";
                    } else {
                        state = attendance.stateHeaderOs;
                    }

                    attendance.stateHeaderOs = state;
                    orderSave.state = attendance.stateHeaderOs;
                    orderSave.enrollment = attendance.enrollment;
                    orderSave.agreement = { id: 1 };
                    orderSave.discount = 0;
                    orderSave.mainPerformer =
                        attendance.mainProfessionalHeaderOs;
                    if (!attendance.mainItemHeaderOs?.id) {
                        this.snackBar.warnMessage(
                            "Selecione um procedimento válido.",
                        );
                        reject("Selecione um procedimento válido.");
                        return;
                    }
                    orderSave.mainProcedure = attendance.mainItemHeaderOs;
                    orderSave.plan = this.order.plan;
                    orderSave.orderPatientDetail = this.setOrderPatientDetails(
                        patient,
                        orderSave,
                    );

                    if (!this.order.id) {
                        let orderItem = new OrderItem();

                        if (this.professionalSolicControl.value?.id) {
                            orderItem.professional =
                                this.professionalSolicControl.value;
                        }

                        if (this.firmSolicControl.value?.id) {
                            orderItem.firm = this.firmSolicControl.value;
                        }

                        if (this.specialityControl.value?.id) {
                            orderItem.speciality = this.specialityControl.value;
                        }

                        if (this.useAccreditationValue == false) {
                            orderItem.value = orderSave.value;
                            orderItem.amount = orderSave.value;
                            orderItem.total = orderSave.value;
                        }

                        orderItem.procedure = orderSave.mainProcedure;
                        orderItem.date = orderSave.date;

                        if (this.auxiliaryList?.length) {
                            orderItem.orderItemAuxiliaryList =
                                this.auxiliaryList;
                        } else {
                            orderItem.orderItemAuxiliaryList = [];
                        }
                        if (this.orderItemFeeList?.length) {
                            orderItem.orderItemFeeList = this.orderItemFeeList;
                        } else {
                            orderItem.orderItemFeeList = [];
                        }

                        // orderItem.orderItemFeeList = this.orderItemFeeList;
                        let productList = new Array<any>();
                        if (this.materialKitList) {
                            this.materialKitList.forEach((material) => {

                                productList.push(material);
                            });
                        }
                        if (this.drugKitList) {
                            this.drugKitList.forEach((drug) => {
                                productList.push(drug);
                            });
                        }
                        if (this.opmeKitList) {
                            this.opmeKitList.forEach((opme) => {

                                productList.push(opme);
                            });
                        }

                        orderItem.orderItemProductList = productList;
                        orderSave.orderItemList = new Array<OrderItem>();
                        orderSave.orderItemList.push(orderItem);
                    }

                    orderSave.orderDiagnosisList = this.cidListSelected;

                    if (!this.order.id) {
                        await this.checkProfessionalNull(orderSave);
                        delete orderSave.orderPatientDetail.id;
                        this.attendanceEditProvider
                            .insert(orderSave)
                            .then((res) => {
                                this._router.navigate([
                                    `operacional/recepcao/os/manter/${this.patient.id}/${res.body.data.id}`,
                                ]);
                                // this.getOrderById(res.body.data.id);
                                // this.disabledSaveAttendance = false;
                                // this.loading = false;

                                // if (res.body.data.insurance.paymentModel == "P") {
                                //     this.selectedTabInfoOrderIndex = 3;

                                // } else {
                                //     this.selectedTabInfoOrderIndex = 1;

                                // }
                                this.refreshService.refreshOrderPayPending();
                                resolve(true);
                            })
                            .catch((err) => {
                                this.osHeaderForm.markAllAsTouched();
                                reject();
                            });
                    } else {
                        orderSave.id = this.order.id;

                        if (
                            orderSave.number == null ||
                            orderSave.number.trim() == "" ||
                            orderSave.number.length == 0
                        ) {
                            this.snackBar.warnMessage(
                                "Número da Guia Obrigatória",
                            );
                            this.osHeaderForm.controls[
                                "numberHeaderOs"
                            ].setValidators([Validators.required]);
                            this.osHeaderForm.controls[
                                "numberHeaderOs"
                            ].updateValueAndValidity();
                            this.osHeaderForm.controls[
                                "numberHeaderOs"
                            ].markAllAsTouched();

                            this.loading = false;
                            this.disabledSaveAttendance = false;
                            reject();
                            return;
                        }

                        // if (attendance.statusHeaderOs == 2 && this.isNoAuth && this.insurance.paymentModel != 'P') {
                        //     this.snackBar.warnMessage('Não é possível fechar ordem de serviço sem informar a autorização!');
                        //     this.loading = false;
                        //     this.disabledSaveAttendance = false;
                        //     return false;
                        // }

                        this.osEdit(orderSave, attendance.statusHeaderOs);
                        resolve(true);
                    }
                } catch (error) {
                    this.snackBar.warnMessage(error.message);
                    this.loading = false;
                    this.disabledSaveAttendance = false;
                    reject();
                }
            });
        }
    }

    onAction(action, value) {
        switch (action) {
            case "COPY":
                this.duplicateItem(value);
                break;

            default:
                break;
        }
    }

    duplicateItem(orderItemId) {
        let dialog = this._matDialog.open(DialogCopyOsComponent, {
            panelClass: "clearPadding",
        });
        dialog.afterClosed().subscribe({
            next: (res) => {
                if (res) {
                    this.attendanceEditProvider
                        .duplicateItem(orderItemId, res)
                        .then((res) => {
                            this.update(true);
                        });
                }
            },
        });
    }

    async checkProfessionalNull(orderSave) {
        let message = "";
        let result = false;
        let action = "confirm";
        if (!orderSave.orderItemList[0]?.professional) {
            if (
                this.requesterRequired == false &&
                this.procedureRequiredProfessionalRequester == false
            ) {
                message = "Guia sem Solicitante informado, deseja continuar?";
            } else {
                message = "Solicitante obrigatório!";
                action = "alert";
                this.professionalSolicControl.markAllAsTouched();
            }
            result = true;
        } else if (
            !this.firmSolicControl.value?.id &&
            this.professionalSolicControl.value?.staff == false
        ) {
            if (this.requesterFirmRequired == false) {
                message =
                    "Solicitante sem a Empresa informada, deseja continuar?";
            } else {
                message = "Empresa do Solicitante obrigatório!";
                action = "alert";
                this.firmSolicControl.markAllAsTouched();
            }

            result = true;
        }

        return new Promise(async (resolve, reject) => {
            if (result == false) {
                resolve(true);
            } else {
                let dialog = this._matDialog.open(FuseConfirmDialogComponent, {
                    disableClose: true,
                });
                dialog.componentInstance.action = action;
                if (action == "confirm") {
                    dialog.componentInstance.confirmMessage = message;
                } else {
                    dialog.componentInstance.alert = true;
                    dialog.componentInstance.showMessage = message;
                }
                dialog.afterClosed().subscribe({
                    next(value) {
                        if (value) {
                            resolve(true);
                        } else {
                            let error = {
                                message: "Registro Não Salvo",
                            };
                            reject(error);
                        }
                    },
                });
            }
        });
    }
    setOrderPatientDetails(patientData, orderSave): OrderPatientDetail {
        const indexArr = [
            //  'plan', 'registration', 'insurance', 'validity', 'product', 'holder'
            "plan",
            "insurance",
        ];
        try {
            // if (patientData) {
            //     Object.keys(patientData).map(function (key) {
            //         if (patientData[key] == '' && indexArr.includes(key)) {
            //             throw new Error("");
            //         }
            //     });
            // }
            let formValue = this.osForm.getRawValue();
            let validaty = null;
            if (moment(formValue.validity).isValid()) {
                validaty = moment(formValue.validity).format("YYYY-MM-DD");
            }

            this.orderPatientDetails.holder = formValue.holder;
            this.orderPatientDetails.plan = formValue.plan;
            this.orderPatientDetails.product = formValue.product;
            this.orderPatientDetails.validity = validaty;
            // ? CwUtils.formatDate(CwUtils.momentToDate(validaty), 'Validade') : validaty;
            this.orderPatientDetails.insurance = formValue.insurance
                ? formValue.insurance
                : formValue;
            this.orderPatientDetails.enrollment = formValue.registration
                ? formValue.registration
                : orderSave.enrollment;

            return this.orderPatientDetails;
        } catch (error) {
            throw new Error(
                "Preencha todos os campos obrigatórios do fomulário de paciente. " +
                error.message,
            );
        }
    }
    initKit(action) {
        switch (action) {
            case "new":
                this.accreditationProcedureKit = [];
                break;
            default:
                break;
        }
        this.attendanceMaterial?.setAccreditationProcedureKit(
            this.accreditationProcedureKit,
            this.insurance,
        );
    }

    getMaMet(procedureId?) {
        this.initKit("new");
        this.feeAccreditationList = [];
        this.orderItemFeeList = [];
        this.materialKitList = [];
        this.drugKitList = [];
        this.opmeKitList = [];
        this.auxiliaryList = [];
        this.orderItemAuxiliaryList = [];
        if (!this.companyControl.value?.id) {
            // this.snackBar.warnMessage('Não foi possivel buscar kit do serviço, informe a empresa e tente novamente;')
            return;
        }
        this.attendanceListProvider
            .getMatMed(
                procedureId,
                this.insurance.id,
                this.companyControl.value?.id,
            )
            .then((res: any) => {
                this.accreditationKitList = res.body;
                this.accreditationProcedureKit = res.body;
                this.initKit("add");
            });
    }

    setKitList(kitListEvent, type) {
        switch (type) {
            case "F":
                this.orderItemFeeList = kitListEvent;
                break;
            case "M":
                this.materialKitList = kitListEvent;
                break;
            case "D":
                this.drugKitList = kitListEvent;
                break;
            case "O":
                this.opmeKitList = kitListEvent;
                break;
            case "A":
                this.auxiliaryList = kitListEvent;
                break;
        }

        this.kitList = new Array();
    }

    changeViewMode() {
        this.hideFormPatient = !this.hideFormPatient;
    }
    //insurance
    getInsuranceList() {
        this.insuranceListProvider
            .getPageSimpleList(this.insurancePgaeOptions, true)
            .then((res) => {
                this.insuranceList = res.body.content;
            });
    }

    handleProceduleSelected(id: number, accreditationId: number) {
        this.accreditationKitList = new Array();
        this.kitList = new Array();
        this.getPerformerByInsuranceAndProcedure(id);
        this.getMaMet(id);
        this.checkParameterProcedure(id);
        this.getParameterValueExameType(id, accreditationId);
        this.checkParameterAccreditation(accreditationId);
    }

    async getOrderById(id) {
        this.getList();
        this.isNewOs = true;

        this.selectedTabIndex = this.TAB_OS;
        this.cidListSelected = [];
        this.selectedTabInfoOrderIndex = 0;
        this.isAdvancePaymentOrder = false;
        this.advancePaymentBudgetId = null;
        this.order = new Order();
        this.osHeaderForm.reset();
        this.loadingOs = true;

        this.AttendanceListProvider.getOrderById(id)
            .then((res: any) => {
                this.loadingOs = false;
                this.order = res.body;
                this.getParametersInsurance(this.order.insurance.id);
                if (
                    this.order.requeryAutorization == true &&
                    !this.order.orderAuthorization?.id
                ) {
                    this.snackBar.warnMessage("Autorização obrigatória!");
                }

                if (this.order.validatyIsBefore == true) {
                    this.snackBar.notifierMessage("simpleMessage", "Aviso", [
                        "Existem itens da OS cuja data ultrapassa a validade da autorização.",
                    ]);
                }

                this.orderPatientDetails = this.order.orderPatientDetail;
                this.osForm.controls["plan"].setValue(
                    this.orderPatientDetails.plan,
                );
                this.osForm.controls["validity"].setValue(
                    this.orderPatientDetails.validity,
                );
                this.osForm.controls["product"].setValue(
                    this.orderPatientDetails.product,
                );
                this.osForm.controls["holder"].setValue(
                    this.orderPatientDetails.holder,
                );
                this.osForm.controls["registration"].setValue(
                    this.orderPatientDetails.enrollment,
                );
                this.cidListSelected = this.order.orderDiagnosisList;
                this.getOrderItemList(this.order.id);
                this.setExameType(this.order.exameType);
                this.handleOsHeader();
                this.getOrderPays();
                this.loadAdvancePaymentOrder();
                this.scrollIntoView();
                this.getProcedurePerfomerByInsurance(this.order.insurance);

                if (
                    this.order.insurance.paymentModel == "P" ||
                    this.order.insurance.paymentModel == "O"
                ) {
                    this.getOrderPayMissing();
                    this.disabledTabOrder = true;
                } else {
                    this.disabledTabOrder = false;
                }

                if (this.selectedTabIndex == this.TAB_HISTORICO) {
                    this.selectedTabIndex = this.TAB_OS;
                }

                setTimeout(() => {
                    this.initFilters();
                    this.getInforOrderBilling();
                }, 5000);

                this.getStateColor(this.order.state);
                this.getState(this.order.state);
                this.getStatus(this.order.status);
                this.getAlerts(this.order);
                this.getParameterValueUsageToken(this.order.insurance.id);
                this.getParameterValueBlockReceipt();
                this.getParameterValueBlockGuide();
            })
            .catch((erro) => {
                this.loading = false;
            });
    }

    scrollIntoView() {
        setTimeout(() => {
            const tabSession = document.getElementById("tab-session");
            if (tabSession) {
                requestAnimationFrame(() => {
                    tabSession.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                });
            }
        }, 500);
    }

    getInforOrderBilling() {
        this.AttendanceListProvider.getinfoOrderBilling(this.order.id).then(
            (res) => {
                this.coverBillingControl.setValue(res.body.cover);
                this.dateBillingControl.setValue(
                    res.body.dateBilling
                );
                this.datePayControl.setValue(
                    res.body.datePay
                );
                this.repasseControl.setValue(
                    res.body.transfers
                );
            },
        );
    }

    getProcedurePerfomerByInsurance(insurance: any) {
        if (insurance) {
            this.insurance = insurance;

            if (this.insurance?.planList?.length == 0) {
                const result = this.insuranceList.filter((insuranceInList) => {
                    return insuranceInList.id == insurance.id;
                });
                this.planList = result[0]?.planList;
            } else {
                this.planList = insurance.planList;
            }
            // this.osHeaderForm.controls["planHeaderOs"].setValue(this.patient.plan)
            // this.order.plan = this.osHeaderForm.controls["planHeaderOs"].value;
            this.getProcedureListByInsurance();
            this.getPerformerByInsuranceAndProcedure();
        }
    }

    observablePlan() {
        this.osHeaderForm.controls["planHeaderOs"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                let filter = "";

                if (typeof res === "string") {
                    filter = res;
                }

                this.planPageOptions.argument = filter;
                this.getPlanList();
            });
    }

    getPlanList() {
        if (this.osHeaderForm.controls.insuranceHeaderOs.value.id == null) {
            return;
        }
        this.planListProvider
            .getPlanSimpleList(
                this.osHeaderForm.controls.insuranceHeaderOs.value?.id,
                this.planPageOptions,
            )
            .then((res) => {
                this.planList = res.body;
            });
    }

    getProcedureListByInsurance() {
        if (!this.companyControl.value?.id) {
            return;
        }

        if (this.insurance && this.insurance.id) {
            this.AttendanceListProvider.getProcedureByInsurance(
                this.insurance.id,
                this.mainProfissional ? this.mainProfissional.id : "",
                this.companyControl.value?.id
                    ? this.companyControl.value.id
                    : "",
                this.procedurePageOptions,
            ).then((res) => {
                this.procedureList = res.body.content;
            });
        }
    }

    getPerformerByInsuranceAndProcedure(procedure?: any) {
        if (this.insurance && this.insurance.id) {
            this.AttendanceListProvider.getPerformer(
                this.performerPageOptions,
                this.insurance.id,
                procedure || "",
            )
                .then((res) => {
                    this.performerList = res.body.content;
                })
                .catch((erro) => { });
        }
    }

    setSpeciality(speciality) { }
    setMainPlan(plan) {
        this.order.plan = plan;
    }

    setMainProfissional(professional) {
        this.mainProfissional = professional;
        this.getProcedureListByInsurance();
    }

    //busca por medico solicitante
    getProfessionalList() {
        this.AttendanceListProvider.getProfessional(
            this.professionalPageOptions,
        ).then((res) => {
            this.profissionalList = res.body.content;
        });
    }

    //busca por medico solicitante por id
    getProfessionalById(professionalId) {
        this.AttendanceListProvider.getProfessionalById(professionalId).then(
            (res) => {
                this.professionalSolicControl.setValue(res.body);
            },
        );
    }

    //Buscar Firma
    getFirmList() {
        this.firmListProvider
            .getPageToOrder(this.firmPageOptions)
            .then((res) => {
                this.firmList = res.body.content;
            });
    }

    getCids() {
        this.AttendanceListProvider.getCids(this.cidPageOptions).then((res) => {
            this.CIDList = res.body.content;
        });
    }

    getProcedurePrice(procedureId: number) {
        this.gw
            .get(
                `insurance/${this.insurance.id}/company/21/procedure/${procedureId}`,
            )
            .toPromise()
            .then((res) => {
                this.osForm.controls["value"].setValue(res.body.value);
            });
    }

    //centro de custo
    async getCompanyCostCenter(value) {
        if (!value?.id) {
            return;
        }

        this.gw.get(`company/companyCostCenter/${value.id}`).subscribe({
            next: (res) => {
                this.companyCostCenterList = res.body;
            },
        });
    }

    getCompanyList() {
        this.companyListProvider
            .getPageSimpleList(this.companyPgaeOptions, "U")
            .then((res) => {
                this.companyList = res.body.content;
            });
    }

    //tipo de Atendimento
    async getTypeSurvey() {
        this.gw
            .get("attendance/exameType/")
            .toPromise()
            .then((res) => {
                this.typeSurveyList = res.body;
            });
    }

    async getParameterValueserviceFrequencyPerWeek(key) {
        this.parameterProvider
            .getValueByParameterOrParameterValueParameter(
                "SERVICE_FREQUENCY_PER_WEEK",
                String(key),
            )
            .then((res) => {
                this.serviceFrequencyPerWeek = res.body;
            });
    }

    async getParameterValueExameType(procedureId, accreditationId) {
        if (accreditationId == null) {
            return;
        }
        this.parameterProvider
            .getValueByExameTypeStandard(procedureId, accreditationId)
            .then((res) => {
                if (res.body.data != null) {
                    this.osHeaderForm.controls[
                        "attendanceTypeHeaderOs"
                    ].setValue(res.body.data);
                    this.exameType = res.body.data;
                }
            });
    }

    async getParameterValueUsageToken(key) {
        this.parameterProvider
            .getValueByParameterOrParameterValueParameter(
                "USAGE_TOKEN",
                String(key),
            )
            .then((res) => {
                this.usageToken = res.body;
            });
    }

    async getParameterValueNumberByInsurance(key) {
        this.parameterProvider
            .getValueByParameterOrParameterValueParameter(
                "GUIDE_BY_INSURANCE",
                String(key),
            )
            .then((res) => {
                this.numberByInsurance = res.body;
            });
    }

    async getParameterValueBlockReceipt() {
        this.parameterProvider
            .getValueByParameterOrParameterValueParameter(
                "BLOCK_RECEIPT_ATTENDANCE",
                String(0),
            )
            .then((res) => {
                this.blockReceipt = res.body == "0" ? false : true;
            });
    }

    async getParameterValueBlockGuide() {
        this.parameterProvider
            .getValueByParameterOrParameterValueParameter(
                "BLOCK_GUIDE_ATTENDANCE",
                String(0),
            )
            .then((res) => {
                this.blockGuide = res.body == "0" ? false : true;
            });
    }

    async getParameterValue(names, key?) {
        if (key) {
            this.parameterProvider
                .getParameterValueByKeyAndNames(key, names)
                .then((res) => {
                    let parameterList: Array<ParameterTO> = res.body;
                    parameterList.forEach((element: ParameterTO) => {
                        switch (element.name) {
                            case "PROCEDURE_ACCEPT_SESSION":
                                if (element.value == "0") {
                                    this.ControlSessionByParameterProcedure = false;
                                } else {
                                    this.ControlSessionByParameterProcedure = true;
                                }
                                break;
                            case "PROCEDURE_REQUIRED_PROFESSIONAL_REQUESTER":
                                if (element.value === "0") {
                                    this.procedureRequiredProfessionalRequester = false;
                                } else {
                                    this.procedureRequiredProfessionalRequester = true;
                                }
                                break;

                            case "ACCREDITATION_PROFESSIONAL_SOLIC":
                                if (
                                    CwUtils.checkStringIsNotNull(element.value)
                                ) {
                                    this.getProfessionalById(element.value);
                                }
                                break;

                            default:
                                break;
                        }
                    });

                    if (this.quatitySessionCurrent > 1) {
                        this.sessionView = this.ControlSessionByParameterSystem
                            ? this.ControlSessionByParameterSystem
                            : this.ControlSessionByParameterProcedure;
                    }
                })
                .catch((err) => { });
        } else {
            const controlSession = this.parameterList.filter(
                (p) => p.name == ParameterNameEnum.CONTROL_SESSION,
            )[0];
            if (controlSession?.value == "0") {
                this.ControlSessionByParameterSystem = false;
            } else {
                this.ControlSessionByParameterSystem = true;
            }
        }
    }

    getParametersInsurance(insuranceId) {
        const names = [
            ParameterNameEnum.INSURACE_ENROLLMENT_MASK,
            ParameterNameEnum.USE_ACCREDITATION_VALUE,
            ParameterNameEnum.REQUESTER_FIRM_REQUIRED,
            ParameterNameEnum.REQUESTER_REQUIRED,
            ParameterNameEnum.USE_DB_DIAGNOSTIC,
            ParameterNameEnum.USE_LAB_CHEKAP,
            ParameterNameEnum.USE_LAB_ALVARO,
            ParameterNameEnum.REQUIRED_CID,
            ParameterNameEnum.USE_SULAMERICA,
        ];
        this.parameterProvider
            .getParameterValueByKeyAndNames(insuranceId, names)
            .then((res) => {
                const parameterList: Array<Parameter> = res.body;
                this.maskRegistration = parameterList.find(
                    (p) => p.name == ParameterNameEnum.INSURACE_ENROLLMENT_MASK,
                ).value;

                const useAccreditation = parameterList.find(
                    (p) => p.name == ParameterNameEnum.USE_ACCREDITATION_VALUE,
                ).value;

                const requesterRequired = parameterList.find(
                    (p) => p.name == ParameterNameEnum.REQUESTER_REQUIRED,
                ).value;

                const requesterFirmRequired = parameterList.find(
                    (p) => p.name == ParameterNameEnum.REQUESTER_FIRM_REQUIRED,
                ).value;

                const webserviceDB = parameterList.find(
                    (p) => p.name == ParameterNameEnum.USE_DB_DIAGNOSTIC,
                ).value;

                const webserviceLabchekap = parameterList.find(
                    (p) => p.name == ParameterNameEnum.USE_LAB_CHEKAP,
                ).value;

                const webserviceLabAlvaro = parameterList.find(
                    (p) => p.name == ParameterNameEnum.USE_LAB_ALVARO,
                ).value;

                const requiredCid = parameterList.find(
                    (p) => p.name == ParameterNameEnum.REQUIRED_CID,
                ).value;

                const useSulAmerica = parameterList.find(
                    (p) => p.name == ParameterNameEnum.USE_SULAMERICA,
                ).value;

                if (requiredCid === "0") {
                    this.cidFormControl.clearValidators();
                    this.cidFormControl.updateValueAndValidity();
                } else {
                    this.cidFormControl.setValidators([Validators.required]);
                    this.cidFormControl.updateValueAndValidity();
                }

                if (webserviceDB === "1") {
                    this.useWebserviceDB = true;
                } else {
                    this.useWebserviceDB = false;
                }

                if (webserviceLabchekap === "1") {
                    this.useWebserviceLabchekap = true;
                } else {
                    this.useWebserviceLabchekap = false;
                }
                 if (webserviceLabAlvaro === "1") {
                    console.log("webserviceLabAlvaro", webserviceLabAlvaro);
                    this.useWebserviceLabAlvaro = true;
                } else {
                    this.useWebserviceLabAlvaro = false;
                }
                if (useAccreditation === "0") {
                    this.useAccreditationValue = false;
                } else {
                    this.useAccreditationValue = true;
                }

                if (requesterRequired === "0") {
                    this.requesterRequired = false;
                } else {
                    this.requesterRequired = true;
                }

                if (requesterFirmRequired === "0") {
                    this.requesterFirmRequired = false;
                } else {
                    this.requesterFirmRequired = true;
                }
                if (useSulAmerica === "1") {
                    this.userWebserviceSulAmerica = true;
                } else {
                    this.userWebserviceSulAmerica = false;
                }
            });
    }

    setExameType(exameType) {
        this.exameType = exameType;
    }

    setMainCostCenter(costCenter) {
        this.mainCostCenter = costCenter;
        this.osHeaderForm.controls["resultCenterHeaderOs"].setValue(
            this.mainCostCenter,
        );
    }

    changeViewByTab(tab) {
        if (this.updatingMainTab) {
            return;
        }

        if (
            this.selectedTabIndex === this.TAB_OS &&
            tab === this.TAB_HISTORICO &&
            this.hasOpenPaymentPending()
        ) {
            this.setMainTab(this.TAB_OS);
            this.confirmLeaveWithOpenPayment().then((canLeave) => {
                if (canLeave) {
                    this.applyViewByTab(tab);
                }
            });
            return;
        }

        this.applyViewByTab(tab);
    }

    private applyViewByTab(tab) {
        this.setMainTab(tab);
        // this.isNewOs = tab == this.TAB_OS;
        if (tab == this.TAB_HISTORICO) {
            $("html, body").animate({
                scrollTop: 0,
            });
            this._router.navigate([
                `operacional/recepcao/os/${this.patient.id}`,
            ]);
            this.scrollIntoView();
        }
        this.action("back");
    }

    changeViewByTabInfoOrder(index) {
        this.scrollIntoView();
        if (index == 1) {
            this.selectedOrderItemIndex = index;
        }
        if (index == 4) {
            this.filterFormPay();
        }
        this.changeViewByTab(this.TAB_OS);
    }

    changeTypeItem(event) {
        this.isProcedure = event.value == "1";
    }

    //list actions

    newOrder() {
        if (
            this.osHeaderForm instanceof FormGroup &&
            this.osHeaderForm.pristine
        ) {
            this.confirmDialogRef = this._matDialog.open(
                FuseConfirmDialogComponent,
                {
                    disableClose: false,
                },
            );
            this.confirmDialogRef.componentInstance.action = "confirm";
            this.confirmDialogRef.afterClosed().subscribe(async (confirm) => {
                if (confirm) {
                    if (this._router.url.endsWith("new")) {
                        this._router.navigate([
                            `operacional/recepcao/os/manter/${this.patient.id}/novo`,
                        ]);
                    } else {
                        this._router.navigate([
                            `operacional/recepcao/os/manter/${this.patient.id}/new`,
                        ]);
                    }
                } else {
                    return;
                }
            });
        } else if (
            this.osHeaderForm instanceof FormGroup &&
            this.osHeaderForm.touched
        ) {
            this.confirmDialogRef = this._matDialog.open(
                FuseConfirmDialogComponent,
                {
                    disableClose: false,
                },
            );
            this.confirmDialogRef.componentInstance.action = "confirm";
            this.confirmDialogRef.afterClosed().subscribe(async (confirm) => {
                if (confirm) {
                    if (this._router.url.endsWith("new")) {
                        this._router.navigate([
                            `operacional/recepcao/os/manter/${this.patient.id}/novo`,
                        ]);
                    } else {
                        this._router.navigate([
                            `operacional/recepcao/os/manter/${this.patient.id}/new`,
                        ]);
                    }
                } else {
                    return;
                }
            });
        } else {
            if (this._router.url.endsWith("new")) {
                this._router.navigate([
                    `operacional/recepcao/os/manter/${this.patient.id}/novo`,
                ]);
            } else {
                this._router.navigate([
                    `operacional/recepcao/os/manter/${this.patient.id}/new`,
                ]);
            }
        }
    }
    selectedOrderRow(order) {
        this._router.navigate([
            `operacional/recepcao/os/manter/${this.patient.id}/${order.id}`,
        ]);
        return;
        this.orderInsurance = order.insurance.paymentMode;

        this.lockCheck.setValue(false);
        this.isNewItemOs = false;
        this.accreditationKitList = [];
        this.kitList = [];
        this.cidListSelected = [];
        this.isNewOs = true;
        this.getOrderById(order.id || order);
        this.selectedTabIndex = this.TAB_OS;
    }

    async addOrder(schedule?) {
        await this.getList();
        if (schedule) {
            setTimeout(() => {
                this.initOrder(schedule);
            }, 500);
        } else {
            setTimeout(() => {
                this.initOrder();
            }, 500);
            // this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            //     disableClose: false
            // });
            // this.confirmDialogRef.componentInstance.action = 'confirm';
            // this.confirmDialogRef.afterClosed().subscribe(async confirm => {
            //     if (confirm) {

            //     }else{
            //         this.changeViewByTab(this.TAB_HISTORICO);
            //     }
            // });
        }
    }

    async initOrder(schedule?) {
        this.isNewOs = true;
        this.loadingOs = true;
        this.accreditationKitList = [];
        this.cidListSelected = [];
        this.order = new Order();
        this.order.companyCostCenter = new CompanyCostCenter();
        this.osHeaderForm.reset();
        this.selectedTabIndex = this.TAB_OS;
        this.osDate = schedule ? schedule.date : moment();
        setTimeout(() => {
            // this.initKit("new");

            this.handleOsHeader(schedule);
            this.setDefaultValues(schedule);
            this.initFilters(); //TODO filter de company
        }, 2000);
        setTimeout(() => {
            this.getProcedurePerfomerByInsurance(
                schedule?.insurance
                    ? schedule.insurance
                    : this.patient?.insurance,
            );
            this.loadingOs = false;
        }, 5000);
        if (schedule != null) {
            setTimeout(() => {
                this.handleProceduleSelected(schedule.procedure.id, null);
            }, 6000);
        }
        setTimeout(() => {
            this.checkDefaulters();
        }, 5000);
    }

    addOrderSchedule(schedule) {
        if (schedule) {
            this.addOrder(schedule);
            if (schedule.scheduleProcedureList?.length > 0) {
                schedule.scheduleProcedureList.forEach((l) => {
                    this.scheduleWhithChilden.push(l);
                });
            }
            this.scheduleId = schedule.id;
            setTimeout(() => {
                localStorage.removeItem("scheduleOs");
            }, 2000);
        }

        // if (scheduleOS?.patient.person.name) {

        //     this.selectedTabIndex = this.TAB_OS;
        //     this.isNewOs = true;
        //     this.accreditationKitList = [];
        //     this.cidListSelected = [];
        //     this.order = new Order();
        //     this.order.companyCostCenter = new CompanyCostCenter();
        //     this.osHeaderForm.reset();
        //     this.handleOsHeader(scheduleOS);
        //     this.initKit("new");
        //     this.setDefaultValues();
        // }
    }

    addOrderItemToList(orderItem) {
        this.getOrderById(this.order.id);
    }

    async back(): Promise<void> {
        if (this.selectedTabIndex == this.TAB_HISTORICO) {
            this._router.navigate([`operacional/recepcao/os`]);
        } else {
            if (await this.confirmLeaveWithOpenPayment()) {
                this.applyViewByTab(this.TAB_HISTORICO);
            }
        }
        // this.location.back()
    }

    changeType(type) {
        this.typeDiscount = type;
    }

    async exclusionMotive(orderitem) {
        orderitem = await this.getOrderItemId(orderitem);
        let objectExclusion = {
            order: this.order,
            orderitem: orderitem,
        };
        this.exclusionDialogRef = this._matDialog.open(
            ExclusionMotiveComponent,
            {
                panelClass: "clearPadding",
                data: objectExclusion,
                disableClose: false,
            },
        );
        this.exclusionDialogRef.afterClosed().subscribe((confirm) => {
            if (confirm) {
                this.osItensList = this.osItensList.filter((orderItem) => {
                    this.update(true);
                    return orderItem.id != orderitem.id;
                });
            }
        });
    }

    osDelete(order?: any, action?) {
        this.getAlerts(order ? order : this.order, 5); // 5 aviso para exclusão
        this.exclusionDialogRef = this._matDialog.open(
            ExclusionMotiveComponent,
            {
                panelClass: "clearPadding",
                data: order ? order : this.order,
                disableClose: false,
            },
        );
        this.exclusionDialogRef.afterClosed().subscribe((confirm) => {
            if (confirm) {
                if (action) {
                    this.changeViewByTab(this.TAB_HISTORICO);
                }
            }
        });
    }

    updateOrder(orderId) {
        if (this._router.url.includes("/editar")) {
            this._router.navigate([
                `operacional/recepcao/os/manter/${this.patient.id}/${orderId}`,
            ]);
        } else {
            this._router.navigate([
                `operacional/recepcao/os//manter/${this.patient.id}/${orderId}/editar`,
            ]);
        }
    }

    osEdit(orderSave, status) {
        this.attendanceEditProvider.edit(orderSave).then((res) => {
            if (this._router.url.includes("/editar")) {
                this._router.navigate([
                    `operacional/recepcao/os/manter/${this.patient.id}/${res.body.data.id}`,
                ]);
            } else {
                this._router.navigate([
                    `operacional/recepcao/os//manter/${this.patient.id}/${res.body.data.id}/editar`,
                ]);
            }
            // // this._router.navigate([`atendimento/os/${this.patient.id}/${res.body.data.id}`])
            // this.getOrderById(res.body.data.id);
            // // this.loading = false;
            // // this.selectedTabInfoOrderIndex = 1;
        });
    }

    detailsOrderItem(orderItem) {
        this.accreditationKitList = [];
        this.kitList = [];
        this.orderItem = orderItem;
        this.isNewItemOs = true;
    }

    checkState() {
        if (
            this.orderStatus === "Normal" ||
            this.orderStatus === "Bloqueada" ||
            this.orderStatus === "Pendente"
        ) {
            return true;
        } else {
            return false;
        }
    }

    checkParameterProcedure(id) {
        const names = [
            ParameterNameEnum.PROCEDURE_ACCEPT_SESSION,
            ParameterNameEnum.PROCEDURE_REQUIRED_PROFESSIONAL_REQUESTER,
        ];
        this.getParameterValue(names, id || "");
    }

    checkParameterAccreditation(id) {
        const names = [ParameterNameEnum.ACCREDITATION_PROFESSIONAL_SOLIC];
        this.getParameterValue(names, id || "");
    }

    /* deleteItem(id) {
     
         this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
             disableClose: false
         });
         this.confirmDialogRef.componentInstance.action = 'delete';
         this.confirmDialogRef.afterClosed().subscribe(confirm => {
             if (confirm) {
     
                 this.attendanceEditProvider.deleteItem(id).then(res => {
                     this.osItensList = this.osItensList.filter(orderItem => {
                         return orderItem.id != id
                     });
                 }).catch(err => {
                 });
             }
         });
     
     }*/

    async getOrderItemId(orderItem) {
        return new Promise<any>((resolve, reject) => {
            this.attendanceListProvider
                .getOrderItemById(orderItem?.id)
                .then((res) => {
                    let itemResult = res;
                    resolve(itemResult);
                })
                .catch((err) => {
                    this.snackBar.warnMessage("Item não localizado");
                });
        });
    }

    getOrderItemList(orderId) {
        this.attendanceListProvider.getOrderItemList(orderId).then((res) => {
            this.osItensList = res.body.data;
        });
    }

    //order pay
    getOrderPays() {
        this.orderPayListProvider
            .getAll(this.order.id, this.orderPayPageOptions)
            .then((res) => {
                this.osPayList = res.body;
            });
    }

    loadAdvancePaymentOrder() {
        this.isAdvancePaymentOrder = false;
        this.advancePaymentBudgetId = null;

        if (!this.order?.id) {
            return;
        }

        this.attendanceListProvider
            .getAdvancePaymentByOrderId(this.order.id)
            .then((res) => {
                const budgetId = res?.body?.budgetId;
                this.isAdvancePaymentOrder = !!budgetId;
                this.advancePaymentBudgetId = budgetId || null;

                if (
                    this.isAdvancePaymentOrder &&
                    this.selectedTabInfoOrderIndex === 4
                ) {
                    this.selectedTabInfoOrderIndex = 0;
                }
            });
    }

    goToAdvancePayment() {
        if (!this.advancePaymentBudgetId) {
            return;
        }

        this._router.navigate([
            `operacional/recepcao/pagamento-antecipado/manter/${this.advancePaymentBudgetId}/editar`,
        ]);
    }

    orderPayDetail(id) {
        this.isDetailsPayment = true;
        this.orderPayId = id;
    }

    async deleteOrderPay(id) {
        await this.orderPayEditProvider.delete(id);
        this.getOrderPays();
        this.getOrderPayMissing();
        this.refreshService.refreshOrderPayPending();
        this.update(true);
    }

    createOrderPayForm(): FormGroup {
        return this._formBuilder.group({
            payType: [null, [Validators.required]],
            parcel: ["1", Validators.required],
            discount: [0],
            notes: [null],
            transactionIdentifier: [null],
            value: [null, Validators.required],
            missing: [null, Validators.required],
            date: [this.order?.date || moment(), Validators.required],
        });
    }

    applyDiscount() {
        if (this.order.state === "") {
        }

        if (this.discountLoading == true) {
            return;
        }
        this.discountLoading = true;
        let applyDiscount = {
            orderId: this.order.id,
            type: this.typeDiscount,
            valueDiscount:
                this.discountControl.value == null
                    ? 0
                    : this.discountControl.value,
        };

        this.orderPayEditProvider
            .applyDiscount(applyDiscount)
            .then((res) => {
                this.update(true);
                this.discountLoading = false;
                this.snackBar.successMessage("Desconto Aplicado!");
            })
            .catch((err) => {
                this.discountLoading = false;
            });

        setTimeout(() => {
            this.discountLoading = false;
        }, 3000);
    }

    async saveOrderPay() {
        this.progress = true;

        if (!this.checkOrderPayForm()) {
            this.progress = false;
            return;
        }
        const data = this.orderPayForm.getRawValue();
        const orderPayMin: OrderPayMin = {
            orderId: this.order.id,
            amountParcel: parseInt(data.parcel),
            payTypeId: data.payType.id,
            date: moment(data.date).format("YYYY-MM-DD"),
            value: data.value,
            notes: data.notes,
            transactionIdentifier: data.transactionIdentifier,
        };


        if (
            data.payType.type == "1" &&
            orderPayMin.value == this.orderPayMissing && this.discountOS != null
        ) {
            let confirm = await this.confirmDiscount();
            if (confirm) {
                orderPayMin.discountOS = this.discountOS;
            }
        }

        this.orderPayEditProvider
            .saveOrderPayMin(orderPayMin)
            .then((res) => {
                this.orderPayForm.controls["payType"].setValue(null);
                this.orderPayForm.controls["notes"].setValue(null);
                this.orderPayForm.controls["transactionIdentifier"].setValue(
                    null,
                );
                this.orderPayForm.controls["parcel"].setValue("1");
                this.orderPayForm.controls["value"].setValue("");
                this.getOrderPays();
                const update = true;
                this.getOrderPayMissing(update);
                this.progress = false;
                this.refreshService.refreshOrderPayPending();
                this.update(true);
            })
            .catch((error) => {
                this.progress = false;
            });
    }

    async confirmDiscount() {
        return new Promise((resolve, reject) => {
            this.confirmDialogRef = this._matDialog.open(
                FuseConfirmDialogComponent,
                {
                    disableClose: false,
                },
            );
            this.confirmDialogRef.componentInstance.action = "confirm";
            this.confirmDialogRef.componentInstance.confirmMessage =
                "Confirma desconto no pagamento em espécie?";
            this.confirmDialogRef.afterClosed().subscribe(async (confirm) => {
                resolve(confirm);

            });
        });
    }

    checkOrderPayForm() {
        let check: boolean = true;
        if (
            this.orderPayForm.controls.payType.invalid ||
            this.orderPayForm.controls.value.invalid
        ) {
            this.orderPayForm.controls.payType.markAsTouched();
            this.orderPayForm.controls.value.markAsTouched();
            this.snackBar.warnMessage("Verifique os campos em destaques.");
            check = false;
        }
        return check;
    }

    filterFormPay() {

        if (this.payTypeSubscription) {
            return;
        }

        this.payTypeSubscription = this.orderPayForm.controls[
            "payType"
        ].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (res?.split == true) {
                    this.togglePayType = false;
                    this.orderPayForm.controls["parcel"].setValue(1);
                    const pattern = `[1-${res.splitMax} ]*`;
                    this.patterQuatityParcel = pattern;
                } else {
                    this.togglePayType = true;
                    this.orderPayForm.controls["parcel"].setValue(0);
                }
            });
    }

    // Get all payTypes
    getPayTypeList() {
        this.payTypeListProvider.getAll().then((res) => {
            this.payTypeList = res.body;
        });
    }

    getOrderPayMissing(update?) {
        this.orderPayListProvider
            .getOrderPayMissingWithDiscountParticular(this.order.id)
            .then((res: any) => {

                this.orderPayMissing = res.body?.valueMissing;
                this.orderPayForm.controls["missing"].setValue(
                    this.orderPayMissing,
                );
                this.orderPayForm.controls["value"].setValue(
                    this.orderPayMissing,
                );
                if (res.body.discountOS != null) {
                    this.discountOS = res.body.discountOS;

                    this.valueAfterDiscount = res.body.valueAfterDiscount;
                } else {
                    this.discountOS = null;
                    this.valueAfterDiscount = null;
                }
                if (res.body?.valueMissing == 0) {
                    // this.navigateChangeStatus();
                } else {
                    this.orderPayForm.enable();
                }
            });
    }

    async generateReportOS(orderid: number) {
        try {
            this.snackBar.successMessage("Gerando guia aguarde...");

            const x = await this.reportprovider.getPdfReportOS(orderid);

            this.pdfSrc = x.pdf as string;

            const newBlob = new Blob([x], { type: "application/pdf" });
            const nav = window.navigator as any;

            if (nav && nav.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(newBlob);
                return;
            }

            window.URL.createObjectURL(newBlob);

            const dialogRef = this._matDialog.open(guiaModal, {
                height: "100%",
                width: "120%",
                data: this.pdfSrc,
            });

            dialogRef.afterClosed().subscribe(() => {
                this.pdfSrc = null;
            });
        } catch (error) {
            console.error(error);
            this.snackBar.errorMessage("Erro ao gerar guia.");
        }
    }

    generateReceipt(orderid: number) {
        if (this.orderPayMissing != "0") {
            this.snackBar.warnMessage("Possui pendência de pagamento");
            return;
        }
        this.snackBar.successMessage("Gerando recibo aguarde...");

        const dialogRef = this._matDialog.open(TypeReceiptComponent, {
            data: this.order,
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.pdfSrc = null;
        });

        /**/
    }

    openDialogDbDiagnostic() {
        const dialogRef = this._matDialog.open(DialogDbProcedureComponent, {
            data: this.order,
            panelClass: "clearPadding",
            width: "90%",
            height: "80%",
            disableClose: true,
        });
        dialogRef.componentInstance.tableName =
            this.useWebserviceDB == true
                ? "DB Diagnostico"
                : this.useWebserviceLabchekap == true
                    ? "Labchekap"
                    : this.useWebserviceLabAlvaro == true
                    ? "LabAlvaro" : "";
        dialogRef.afterClosed().subscribe((result) => { });

        /**/
    }

    openAttest(orderid: number) {
        this.pdfSrc = null;
        const confirmDialogRef = this._matDialog.open(
            AttestAttendanceComponent,
            {
                data: {
                    type: 3,
                    nameDocument: "Atestado",
                    patient: this.patient,
                    performer: this.order.mainPerformer,
                    documentId: null,
                },
                autoFocus: false,
                width: "100%",
                maxWidth: "100%",
                height: "100%",
                disableClose: true,
            },
        );

        confirmDialogRef.afterClosed().subscribe((result) => { });
    }

    //reports
    async generateReport(
        download?: boolean,
        orderToList?: Order,
        printToList?: boolean,
    ) {
        this.loadingAction = true;
        this.progressBar.show();

        let order = orderToList ? orderToList : this.order;

        try {
            if (order.insurance.paymentModel == "P") {
                await this.generateReportOS(order.id);
                return;
            }

            this.snackBar.successMessage("Gerando guia aguarde...");

            const x = await this.reportprovider.getPdfGuide(order.id);

            this.pdfSrc = x.pdf as string;

            const newBlob = new Blob([x], { type: "application/pdf" });

            const nav = window.navigator as any;

            if (nav && nav.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(newBlob);
                return;
            }

            window.URL.createObjectURL(newBlob);

            const dialogRef = this._matDialog.open(guiaModal, {
                height: "100%",
                width: "100%",
                maxHeight: "100%",
                maxWidth: "100%",
                data: this.pdfSrc,
            });

            dialogRef.afterClosed().subscribe(() => {
                this.pdfSrc = null;
            });
        } catch (error) {
            console.error(error);
            this.snackBar.errorMessage("Erro ao gerar guia.");
        } finally {
            this.loadingAction = false;
            this.progressBar.hide();
        }

        return false;
    }

    downloadFile(data) {
        const blob = new Blob([data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
    }

    setDefaultValues(schedule?) {
        moment.locale("pt-br");
        this.AttendanceListProvider.getDefaultValues(this.patient.id).then(
            (res: any) => {
                this.osHeaderForm.controls["numberHeaderOs"].setValue("");
                this.osHeaderForm.controls["dateHeaderOs"].setValue(
                    CwUtils.momentToDate(moment()),
                );

                if (!schedule) {
                    this.getCompanyCostCenter(res.body.company);
                    this.osHeaderForm.controls["resultCenterHeaderOs"].setValue(
                        res.body.companyCostCenterPO,
                    );
                    this.companyControl.setValue(res.body.company);
                    this.companySelectd = res.body.company;

                    this.osHeaderForm.controls["mainItemHeaderOs"].setValue(
                        res.body.procedure,
                    );
                    this.osHeaderForm.controls[
                        "mainProfessionalHeaderOs"
                    ].setValue(res.body.performer);
                    if (res.performer) {
                        this.getSpeciality(res.performer.professional.id);
                    }
                } else if (schedule) {
                    if (schedule?.company?.id != res.body?.company?.id) {
                        this.getCompanyCostCenter(schedule.company);
                        this.companyControl.setValue(schedule.company);
                        this.companySelectd = schedule.company;
                    } else {
                        this.getCompanyCostCenter(res.body.company);
                        this.osHeaderForm.controls[
                            "resultCenterHeaderOs"
                        ].setValue(res.body.companyCostCenterPO);
                        this.companyControl.setValue(res.body.company);
                        this.companySelectd = res.body.company;
                    }
                }
                const hourMoment = moment(res.body.hour, "HH:mm:ss.SSSSSS");
                const formattedHour = hourMoment.format("HH:mm");
                this.osHeaderForm.controls["hourHeaderOs"].setValue(
                    formattedHour,
                );

                if (res.body.cid != null) {
                    let cidDiagnosis = new OrderDiagnosis();
                    cidDiagnosis.cid = res.body.cid;
                    cidDiagnosis.main = true;
                    this.cidListSelected.push(cidDiagnosis);
                }
                this.osDate = moment();
                this.professionalSolicControl.setValue(res.body.solic);
            },
        );
        this.osHeaderForm.controls["statusHeaderOs"].setValue("1");

        this.osHeaderForm.controls["attendanceTypeHeaderOs"].setValue(
            this.typeSurveyList[0],
        );
        this.exameType = this.typeSurveyList[0];

        this.osHeaderForm.controls["typeHeaderOs"].setValue("1");
        this.osHeaderForm.controls["quantity"].setValue(1);

        // setTimeout(() => {
        //     $('#item-main').focus();

        // }, 1000)
    }
    async getOrderByIdForGuide(id) {
        return new Promise((resolve, reject) => {
            this.AttendanceListProvider.getOrderById(id)
                .then((res: any) => {
                    resolve(res.body);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async generateReportProtocolDelivery(orderId: number) {
        try {
            this.snackBar.successMessage("Gerando guia aguarde...");

            const x = await this.reportprovider.generateReportProtocolDelivery(orderId);

            this.pdfSrc = x.pdf as string;

            const newBlob = new Blob([x], { type: "application/pdf" });
            const nav = window.navigator as any;

            if (nav && nav.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(newBlob);
                return;
            }

            window.URL.createObjectURL(newBlob);

            const dialogRef = this._matDialog.open(guiaModal, {
                height: "100%",
                width: "120%",
                data: this.pdfSrc,
            });

            dialogRef.afterClosed().subscribe(() => {
                this.pdfSrc = null;
            });
        } catch (error) {
            console.error(error);
            this.snackBar.errorMessage("Erro ao gerar guia.");
        }
    }

    generateReportSheetOS(orderid: number) {
        this.snackBar.successMessage("Gerando folha de laudo aguarde...");

        this.reportprovider.getPdfReportSheetOS(orderid).then((x) => {
            this.pdfSrc = x.pdf as string;

            var newBlob = new Blob([x], { type: "application/pdf" });

            const nav = window.navigator as any;

            if (nav && nav.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(newBlob);
                return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);

            this.progressBar.hide();
            const dialogRef = this._matDialog.open(guiaModal, {
                height: "100%",
                width: "120%",
                data: this.pdfSrc,
            });

            dialogRef.afterClosed().subscribe((result) => {
                this.pdfSrc = null;
            });
        });
    }

    update(event) {
        this.getOrderPays();
        this.AttendanceListProvider.getOrderById(this.order.id).then(
            (res: any) => {
                this.order = res.body;
                this.handleOsHeader();
                this.getOrderPayMissing();
                this.getOrderItemList(this.order.id);
                //this.osHeaderForm.controls['value'].setValue(this.order.value);
            },
        );

        //this.getOrderById(this.order.id)
    }

    orderAuthorization(event) {
        this.order.orderAuthorization = event;
    }

    alterOrderPayer() {
        this.isOrderPayer = !this.isOrderPayer;
    }

    getIsOrderPayerList(event) {
        this.isOrderPayerList = event;
    }

    getOrderPayerDetail(event) {
        this.orderPayerDetail = event;
        this.isOrderPayerList = false;
    }

    newOrderPayer(event) {
        this.orderPayerDetail = null;
        this.isOrderPayerList = event;
    }

    isOrderPayerEmmit(event) {
        this.isOrderPayer = event;
    }

    displayCompanyFn(company?: any): string | undefined {
        if (!company) {
            return "";
        }
        return company.alias ? company.alias : company;
    }

    addThirdParty(orderItem: any) {
        const dialog = this._matDialog.open(ThirdpartyOrderItemEditComponent, {
            panelClass: "clearPadding",
            disableClose: false,
            data: { orderItem: orderItem, orderStatus: this.orderStatus },
            width: "60%",
            height: "60%",
        });

        dialog.afterClosed().subscribe((result) => {
            if (result) {
                //this.getThirdPartyParticipationList();
            }
        });
    }

    updateInsuranceInOrder() {
        let dialog = this._matDialog.open(DialogChangeInsurance, {
            panelClass: "clearPadding",
            disableClose: false,
            width: "40%",
        });

        dialog.componentInstance.iOrderId = this.order.id;

        dialog.afterClosed().subscribe((res) => {
            this.navigateChangeStatus();
        });
    }

    verifyEligibility() {
        if (this.userWebserviceSulAmerica) {
            let enrollment = "";
            if (CwUtils.checkStringIsNotNull(this.osHeaderForm.controls["enrollment"].value)) {
                enrollment = this.osHeaderForm.controls["enrollment"].value;
            }

            if (!CwUtils.checkStringIsNotNull(enrollment)) {
                this.snackBar.warnMessage("Matrícula não informada");
                this.osHeaderForm.controls["enrollment"].markAllAsTouched();
                return;
            }

            if (!this.osHeaderForm.controls["insuranceHeaderOs"].value?.id) {
                this.snackBar.warnMessage("Convênio não informado");
                this.osHeaderForm.controls["insuranceHeaderOs"].markAsTouched();
                return;
            }

            this.loadingverifyEligibility = true;
            this.integrationService
                .checkEligibilitySulamerica(enrollment, this.osHeaderForm.controls["insuranceHeaderOs"].value?.id)
                .then((res: any) => {
                   var result = res.body.data;
                    this.snackBar.notifierMessage(
                        "authorizerWS",
                         result.status === "SUCESSO" ? "Aviso" : "Atenção",
                        result.responseMessageTOList,
                        0,
                        result.status === "SUCESSO" ? "success" : "error"
                    );
                     this.loadingverifyEligibility = false;
                    
                }).catch((err) => {
                      this.snackBar.notifierMessage(
                        "authorizerWS",
                        "Aviso",
                        ["TESTE"],
                        0,
                        "error"
                    );
                     this.loadingverifyEligibility = false;
                    console.log("🚀 ~ OSComponent ~ verifyEligibility ~ err:", err)
                });
        }

    }
}


@Component({
    selector: "dialog-content-example-dialog",
    templateUrl: "guiaModal.html",
})
export class guiaModal implements OnInit {
    public ngxExtendedPdfViewerConfig: any = {
        printResolution: 300, // Define a resolução de impressão como 300 DPI
    };

    pdf: any;

    constructor(
        public dialogRef: MatDialogRef<guiaModal>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }
    ngOnInit(): void {
        this.pdf = this.data;
    }

    dimiss() {
        this.dialogRef.close();
    }
}
